'use strict';
var $document = $(document),
  $window = $(window),
  $body = $('body'),
  $html = $('html'),
  $ptPageContent = $('#pt-pageContent'),
  $ptFooter = $('footer'),
  $ptHeader = $('header'),
  $ptLeftColumnAside = $ptPageContent.find('.leftColumn.aside'),
  $ptFilterOptions = $ptPageContent.find('.pt-filters-options'),
  header_menu_timeout = 150,
  header_menu_delay = 150,
  $ptTopPanel = $('.pt-top-panel'),
  $stucknav = $ptHeader.find('.pt-stuck-nav'),
  $ptDesctopMenu = $ptHeader.find('.pt-desctop-menu'),
  $ptDesctopParentMenu = $ptHeader.find('.pt-desctop-parent-menu'),
  $ptMobileParentMenu = $ptHeader.find('.pt-mobile-parent-menu'),
  $ptMobileParentMenuChildren = $ptMobileParentMenu.children(),
  $ptStuckParentMenu = $ptHeader.find('.pt-stuck-parent-menu'),
  $ptSearchObj = $ptHeader.find('.pt-search'),
  $ptDesctopParentSearch = $ptHeader.find('.pt-desctop-parent-search'),
  $ptMobileParentSearch = $ptHeader.find('.pt-mobile-parent-search'),
  $ptStuckParentSearch = $ptHeader.find('.pt-stuck-parent-search'),
  $ptSearchObjPopupInput = $ptSearchObj.find('.pt-search-input'),
  $ptSearchObjPopupResults = $ptSearchObj.find('.search-results'),
  $ptcartObj = $ptHeader.find('.pt-cart'),
  $ptDesctopParentCart = $ptHeader.find('.pt-desctop-parent-cart'),
  $ptMobileParentCart = $ptHeader.find('.pt-mobile-parent-cart'),
  $ptStuckParentCart = $ptHeader.find('.pt-stuck-parent-cart'),
  $ptAccountObj = $ptHeader.find('.pt-account'),
  $ptDesctopParentAccount = $ptHeader.find('.pt-desctop-parent-account'),
  $ptMobileParentAccount = $ptHeader.find('.pt-mobile-parent-account'),
  $ptStuckParentAccount = $ptHeader.find('.pt-stuck-parent-account'),
  $ptCompareObj = $ptHeader.find('.pt-compare'),
  $ptDesctopParentCompare = $ptHeader.find('.pt-desctop-parent-compare'),
  $ptMobileParentCompare = $ptHeader.find('.pt-mobile-parent-compare'),
  $ptStuckParentCompare = $ptHeader.find('.pt-stuck-parent-compare'),
  $ptWishlistObj = $ptHeader.find('.pt-wishlist'),
  $ptDesctopParentWishlist = $ptHeader.find('.pt-desctop-parent-wishlist'),
  $ptMobileParentWishlist = $ptHeader.find('.pt-mobile-parent-wishlist'),
  $ptStuckParentWishlist = $ptHeader.find('.pt-stuck-parent-wishlist'),
  blocks = {
    ptCalendarDatepicker: $ptPageContent.find('.calendarDatepicker'),
    ptSliderBlog: $ptPageContent.find('.pt-slider-blog'),
    ptSlickMain: $ptPageContent.find('.pt-slick-main'),
    ptSliderBlogSingle: $ptPageContent.find('.pt-slider-blog-single'),
    ptVideoBlock: $('.pt-video-block'),
    ptBlogMasonry: $ptPageContent.find('.pt-blog-masonry'),
    ptPortfolioMasonry: $ptPageContent.find('.pt-portfolio-masonry'),
    ptProductMasonry: $ptPageContent.find('.pt-product-listing-masonry'),
    ptInputCounter: $('.pt-input-counter'),
    ptCollapseBlock: $('.pt-collapse-block'),
    modalVideoProduct: $('#modalVideoProduct'),
    modalAddToCart: $('#modalAddToCartProduct'),
    ptMobileProductSlider: $('.pt-mobile-product-slider'),
    ptCollapse: $ptPageContent.find('.pt-collapse'),
    ptProductListing: $ptPageContent.find('.pt-product-listing'),
    ptBtnColumnClose: $ptLeftColumnAside.find('.pt-btn-col-close'),
    ptBtnToggle: $ptFilterOptions.find('.pt-btn-toggle a'),
    ptProductItem: $ptPageContent.find('.pt-product, .pt-product-design02'),
    ptProductDesign02: $ptPageContent.find('.pt-product-design02'),
    ptProductDesign01: $ptPageContent.find('.pt-product'),
    ptFilterDetachOption: $ptLeftColumnAside.find('.pt-filter-detach-option'),
    ptFilterSort: $ptFilterOptions.find('.pt-sort'),
    ptSliderLookbook: $ptPageContent.find('.pt-slider-lookbook'),
    ptPortfolioContent: $ptPageContent.find('.pt-portfolio-content'),
    ptLookbook: $ptPageContent.find('.pt-lookbook'),
    ptAirSticky: $ptPageContent.find('.airSticky'),
    ptfooterMobileCollapse: $ptFooter.find('.pt-collapse-title'),
    ptBackToTop: $('.pt-back-to-top'),
    ptHeaderDropdown: $ptHeader.find('.pt-dropdown-obj'),
    ptCarouselProducts: $('.pt-carousel-products'),
    ptItemsCategories: $ptPageContent.find('.pt-items-categories'),
    ptDotsAbsolute: $ptPageContent.find('.pt-dots-absolute'),
    ptAlignmentImg: $ptPageContent.find('.pt-alignment-img'),
    ptProductSingleBtnZomm: $ptPageContent.find('.pt-product-single-img .pt-btn-zomm'),
    ptRevolutionPromo: $ptPageContent.find('.pt-revolution-promo'),
    ptTabsGorizontal: $('#pt-pageContent .pt-tabs-gorizontal-js'),
  },
  ptwindowWidth = window.innerWidth || $window.width();
if (
  (blocks.ptRevolutionPromo.length &&
    (setTimeout(function () {
      blocks.ptRevolutionPromo.fadeTo('90', 1);
    }, 2300),
    blocks.ptRevolutionPromo.on('click', '.pt-btn-close', function () {
      $(this).closest('.pt-revolution-promo').hide();
    })),
  blocks.ptItemsCategories.length && ptItemsCategories(),
  blocks.modalAddToCart.length && modalAddToCart(),
  $('.mainmenumob-js').length)
) {
  var mobileMenuToggle = $('.pt-menu-toggle'),
    mobileCaterorieMenu = $('.mobile-categorie-menu'),
    panelMenu = $('.panel-menu');
  if (mobileCaterorieMenu.length) {
    var objCategories = mobileCaterorieMenu.find('ul:first-child').detach(),
      categtext = mobileCaterorieMenu.find('.catsvg-text').html() + mobileCaterorieMenu.find('.catsvg-nextlvlicon').html();
    panelMenu.find('ul:first-child').prepend("<li id='wrap-categories'><a href='index.html'>" + categtext + '</a></li>'), panelMenu.find('#wrap-categories').append(objCategories);
  }
  $('.mainmenumob-js').initMM({ enable_breakpoint: !0, mobile_button: !0, breakpoint: 1025, menu_class: 'mobile-main-menu', external_container: !0 });
}
if (
  ($ptTopPanel.length && ptTopPanel(),
  blocks.ptBackToTop.length && ptBackToTop(),
  $ptLeftColumnAside && blocks.ptBtnColumnClose && blocks.ptBtnToggle && ptToggleCol(),
  blocks.ptCollapse.length && ptCollapse(),
  blocks.modalVideoProduct.length && ptVideoPopup(),
  blocks.ptCollapseBlock.length && ptCollapseBlock(),
  blocks.ptCalendarDatepicker.length && blocks.ptCalendarDatepicker.datepicker(),
  blocks.ptVideoBlock.length && ptVideoBlock(),
  -1 !== getInternetExplorerVersion() && $html.addClass('ie'),
  blocks.ptInputCounter.length && ptInputCounter(),
  initStuck(),
  $ptDesctopParentSearch.length && mobileParentSearch(),
  $ptcartObj.length && mobileParentCart(),
  blocks.ptProductDesign01.length && ptProductHover(),
  blocks.ptfooterMobileCollapse.length && ptFooterCollapse(),
  blocks.ptLookbook.length && ptLookbook(ptwindowWidth),
  blocks.ptCarouselProducts.length &&
    blocks.ptCarouselProducts.each(function () {
      var t = $(this),
        e = $(this).data('item');
      t.slick({
        dots: !0,
        arrows: !0,
        infinite: !0,
        speed: 300,
        slidesToShow: e || 4,
        slidesToScroll: e || 4,
        adaptiveHeight: !0,
        responsive: [
          { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 791, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        ],
      });
    }),
  blocks.ptSliderLookbook.length && blocks.ptSliderLookbook.slick({ dots: !0, arrows: !0, infinite: !0, speed: 300, slidesToShow: 1, adaptiveHeight: !0 }),
  blocks.ptMobileProductSlider.length && blocks.ptMobileProductSlider.slick({ lazyLoad: 'progressive', dots: !1, arrows: !0, infinite: !0, speed: 300, slidesToShow: 1, adaptiveHeight: !0 }),
  blocks.ptSlickMain.length &&
    blocks.ptSlickMain.slick({ dots: !0, arrows: !0, infinite: !0, speed: 300, slidesToShow: 1, adaptiveHeight: !0, responsive: [{ breakpoint: 1025, settings: { dots: !1 } }] }),
  blocks.ptSliderBlog.length && blocks.ptSliderBlog.slick({ dots: !1, arrows: !0, infinite: !0, speed: 300, slidesToShow: 1, adaptiveHeight: !0 }),
  blocks.ptSliderBlogSingle.length)
) {
  blocks.ptSliderBlogSingle.slick({ dots: !1, arrows: !1, infinite: !0, speed: 300, slidesToShow: 1, adaptiveHeight: !0 });
  var ptSlickQuantity = $('.pt-slick-quantity');
  ptSlickQuantity.length &&
    (ptSlickQuantity.find('.total').html(blocks.ptSliderBlogSingle.slick('getSlick').slideCount),
    blocks.ptSliderBlogSingle.on('afterChange', function (t, e, n) {
      var o = $('.slick-current').attr('data-slick-index');
      o++, ptSlickQuantity.find('.account-number').html(o);
    }));
  var ptSlickButton = $('.pt-slick-button');
  ptSlickButton.length &&
    (ptSlickButton.find('.slick-next').click(function () {
      blocks.ptSliderBlogSingle.slick('slickNext');
    }),
    ptSlickButton.find('.slick-prev').click(function () {
      blocks.ptSliderBlogSingle.slick('slickPrev');
    }));
}
blocks.ptPortfolioContent.length && is_touch_device() && ptPortfolioContentMobile(),
  blocks.ptDotsAbsolute.length && ptSlickDots(),
  blocks.ptAirSticky.length && ptAirSticky(ptwindowWidth),
  blocks.ptHeaderDropdown.length && ptHeaderDropdown(),
  blocks.ptProductSingleBtnZomm.length && ptProductSingleBtnZomm(),
  $window.on('load', function () {
    var t = window.innerWidth || $window.width();
    $body.length && $body.addClass('loaded'),
      $ptFilterOptions.length && ptFilterLayout(t),
      blocks.ptProductItem.length && ptProductSmall(t),
      blocks.ptProductDesign02.length && ptOverflowProduct(),
      blocks.ptProductMasonry.length && gridProductMasonr(),
      blocks.ptBlogMasonry.length && gridGalleryMasonr(),
      blocks.ptPortfolioMasonry.length && (gridPortfolioMasonr(), initPortfolioPopup());
  });
var ptCachedWidth = $window.width();
$window.on('resize', function () {
  var t = $window.width();
  if (t !== ptCachedWidth) {
    ptCachedWidth = t;
    var e = window.innerWidth || $window.width();
    $ptFilterOptions.length && ptFilterLayout(e),
      blocks.ptProductItem.length && ptProductSmall(),
      blocks.ptProductDesign02.length && ptOverflowProduct(),
      blocks.ptPortfolioContent.length && is_touch_device() && ptPortfolioContentMobile(),
      blocks.ptAirSticky.length && ptAirSticky(e),
      $ptLeftColumnAside.hasClass('column-open') && $ptLeftColumnAside.length && $ptLeftColumnAside.find('.pt-btn-col-close a').trigger('click'),
      $ptDesctopParentSearch.length && mobileParentSearch(),
      $ptcartObj.length && mobileParentCart(),
      blocks.ptDotsAbsolute.length && ptSlickDots();
  }
});
var cssFix = (function () {
  var t = navigator.userAgent.toLowerCase(),
    e = function (e) {
      return -1 != t.indexOf(e);
    };
  $html.addClass(
    [
      !/opera|webtv/i.test(t) && /msie (\d)/.test(t)
        ? 'ie ie' + RegExp.$1
        : e('firefox/2')
        ? 'gecko ff2'
        : e('firefox/3')
        ? 'gecko ff3'
        : e('gecko/')
        ? 'gecko'
        : e('opera/9')
        ? 'opera opera9'
        : /opera (\d)/.test(t)
        ? 'opera opera' + RegExp.$1
        : e('konqueror')
        ? 'konqueror'
        : e('applewebkit/')
        ? 'webkit safari'
        : e('mozilla/')
        ? 'gecko'
        : '',
      e('x11') || e('linux') ? ' linux' : e('mac') ? ' mac' : e('win') ? ' win' : '',
    ].join('')
  );
})();
function ptTopPanel() {
  $ptTopPanel.on('click', function (t) {
    t.preventDefault;
    var e = t.target;
    $('.pt-btn-close').is(e) && $(this).slideUp(200);
  });
}
function ptItemsCategories() {
  blocks.ptItemsCategories.hover(function () {
    $(this).toggleClass('active');
  });
}
function ptHeaderDropdown() {
  $('.header-popup-bg').length || $body.append('<div class="header-popup-bg"></div>'),
    $('header').on('click', '.js-dropdown', function (t) {
      var e,
        n = window.innerWidth || $window.width(),
        o = $(this),
        i = t.target,
        a = $('.pt-search'),
        s = a.find('.pt-search-input');
      if ((o.hasClass('pt-search') && $('.pt-dropdown-toggle').is(i) && (o.addClass('active'), $body.addClass('pt-open-search'), s.focus()), a.find('.pt-btn-close').is(i)))
        return o.removeClass('active'), s.blur(), $body.removeClass('pt-open-search'), !1;
      function r() {
        return $('.js-dropdown.active').removeClass('active'), $body.removeClass('pt-popup-dropdown'), $('header .pt-dropdown-menu').removeClass('perfectScrollbar').perfectScrollbar('destroy'), !1;
      }
      !$(this).hasClass('pt-search') &&
        $('.pt-dropdown-toggle').is(i) &&
        (n <= 1024
          ? ((e = o),
            $('header').find('.js-dropdown.active').removeClass('active'),
            e.toggleClass('active').find('.pt-dropdown-menu').removeAttr('style'),
            $body.toggleClass('pt-popup-dropdown'),
            $('header .pt-dropdown-menu').perfectScrollbar().addClass('perfectScrollbar'))
          : (function (e) {
              var n = e,
                o = t.target;
              if (n.hasClass('active')) return n.toggleClass('active').find('.pt-dropdown-menu').slideToggle(200), void n.find('.ps-container').removeAttr('style');
              if (
                ($('.pt-desktop-header .pt-dropdown-obj').each(function () {
                  var t = $(this);
                  t.hasClass('active') && t.removeClass('active').find('.pt-dropdown-menu').css('display', 'none');
                }),
                $('.pt-dropdown-toggle').is(o) && n.toggleClass('active').find('.pt-dropdown-menu').slideToggle(200),
                n.hasClass('pt-cart'))
              ) {
                $.fn.getRealDimensions = function (t) {
                  var e = $(this);
                  if (0 == e.length) return !1;
                  var n = e.clone().show().css('visibility', 'hidden').insertAfter(e),
                    o = { width: t ? n.outerWidth() : n.innerWidth(), height: t ? n.outerHeight() : n.innerHeight(), offsetTop: n.offset().top, offsetLeft: n.offset().left };
                  return n.remove(), o;
                };
                var i = $('.pt-cart-content').first().getRealDimensions().height,
                  a = window.innerHeight,
                  s = i + $('#pt-header').height(),
                  r = $('.pt-stuck-nav');
                if (r.hasClass('stuck')) var l = a - r.height();
                else l = a - $('#pt-header').height();
                a <= s &&
                  $('header .pt-dropdown-menu .pt-cart-layout')
                    .css({ height: l + 'px' })
                    .perfectScrollbar()
                    .addClass('perfectScrollbar'),
                  $(window).resize(function (t) {
                    $('.pt-cart').hasClass('active') && $('.pt-cart .pt-dropdown-toggle').trigger('click');
                  });
              }
            })(o)),
        $(document).mouseup(function (t) {
          var e = window.innerWidth || $window.width();
          o.is(t.target) ||
            0 !== o.has(t.target).length ||
            o.each(function () {
              o.hasClass('active') && o.hasClass('pt-search') && a.find('.pt-btn-close').trigger('click'),
                o.hasClass('active') &&
                  !o.hasClass('pt-search') &&
                  (e <= 1024
                    ? r()
                    : $('.js-dropdown').each(function () {
                        $(this).hasClass('active') && $(this).removeClass('active').find('.pt-dropdown-menu').css('display', 'none');
                      }));
            }),
            o.find('.pt-mobile-add .pt-close').is(t.target) && r();
        });
    });
}
function ptBackToTop() {
  blocks.ptBackToTop.on('click', function (t) {
    return $('html, body').animate({ scrollTop: 0 }, 500), !1;
  }),
    $window.scroll(function () {
      $window.scrollTop() > 500 ? blocks.ptBackToTop.stop((!0).false).addClass('pt-show') : blocks.ptBackToTop.stop((!0).false).removeClass('pt-show');
    });
}
function modalAddToCart() {
  blocks.modalAddToCart.on('click', '.btn-close-popup', function (t) {
    return $(this).closest('.modal-content').find('.modal-header .close').trigger('click'), !1;
  });
}
function ptFooterCollapse() {
  blocks.ptfooterMobileCollapse.on('click', function (t) {
    t.preventDefault;
    var e = $(this).next(),
      n = window.innerWidth || $window.width();
    $(this).toggleClass('pt-open'), 'none' == e.css('display') && n <= 790 ? e.animate({ height: 'show' }, 300) : 'block' == e.css('display') && n <= 790 && e.animate({ height: 'hide' }, 300);
  });
}
function ptSlickDots() {
  blocks.ptDotsAbsolute.each(function () {
    var t = $(this).find('.slick-dots');
    if (t.is(':visible')) {
      var e = t.closest('[class ^= container]');
      e.length && e.css({ paddingBottom: parseInt(t.height(), 10) + parseInt(t.css('marginTop'), 10) });
    }
  });
}
function ptProductHover() {
  $document.on('mouseenter mouseleave', '#pt-pageContent .pt-product', function (t) {
    if ($('.pt-product-listing').length && $('.pt-product-listing').hasClass('pt-col-one')) return !1;
    var e = $(this),
      n = window.innerWidth,
      o = e.find('.pt-description'),
      i = e.find('.pt-product-inside-hover'),
      a = parseInt(i.height()) + 3,
      s = e.find('.pt-countdown_box');
    if ((t.target, e.hasClass('product-nohover'))) return !1;
    'mouseenter' === t.type && n > 1024
      ? (e.stop().css({ height: e.innerHeight() }).addClass('hovered'), o.stop().animate({ top: '-' + a }, 200), i.stop().animate({ opacity: 1 }, 400), s.stop().animate({ bottom: a }, 200))
      : 'mouseleave' === t.type &&
        t.relatedTarget &&
        n > 1024 &&
        (e.stop().removeClass('hovered').removeAttr('style'),
        o.stop().animate({ top: '0' }, 200, function () {
          $(this).removeAttr('style');
        }),
        i.stop().animate({ opacity: 0 }, 100, function () {
          $(this).removeAttr('style');
        }),
        s.stop().animate({ bottom: 0 }, 200, function () {
          $(this).removeAttr('style');
        }));
  });
}
function ptProductSmall() {
  var t = parseInt(blocks.ptProductItem.width(), 10),
    e = $('.pt-product, .pt-product-design02');
  t <= 210 ? e.addClass('pt-small') : e.removeClass('pt-small');
}
function placeArrows(t) {
  $('.js-align-arrow').each(function () {
    var t = $(this),
      e = t.find('.slick-prev').height();
    setTimeout(function () {
      var n = t.find('img').first().height(),
        o = parseInt(n / 2 + (e > 40 ? 67 : 38));
      t.find('.slick-arrow').css('top', o);
    }, 700);
  });
}
function ptLookbook(t) {
  $('.pt-lookbook-popup').length || $body.append('<div class="pt-lookbook-popup"><div class="pt-lookbook-container"></div></div>');
  var e = 'ontouchstart' in window ? 'click' : 'click mouseenter';
  blocks.ptLookbook.on(e, '.pt-hotspot', function (t) {
    var e = $(this),
      n = (t.target, $('.pt-hotspot'), window.innerWidth || $window.width()),
      o = $('.pt-btn').innerHeight() / 2,
      i = $('.pt-hotspot-content').innerWidth();
    function a(t, o, a) {
      n / 2 < a
        ? (function (t) {
            $('.pt-lookbook-popup').css({ top: o, left: t, display: 'block' }, 300).animate({ marginLeft: '26px', opacity: 1 }, 300);
          })(a - i - 7)
        : (function (t) {
            $('.pt-lookbook-popup').css({ top: o, left: t, display: 'block' }).animate({ marginLeft: '-26px', opacity: 1 });
          })(a + 45),
        $('.pt-lookbook-popup').find('.pt-lookbook-container').append(t),
        e.addClass('active').siblings().removeClass('active');
    }
    if (
      (n <= 789
        ? (function (t) {
            var e = t.attr('data-top') + '%',
              n = t.attr('data-left') + '%';
            t.find('.pt-btn').css({ top: e, left: n }),
              t.css({ top: '0px', left: '0px', width: '100%', height: '100%' }),
              t.addClass('active').siblings().removeClass('active'),
              t.find('.pt-content-parent').fadeIn(200);
          })(e)
        : (function (t) {
            if (!t.hasClass('active')) {
              var e = t.offset().top + o,
                i = t.offset().left,
                l = t.find('.pt-hotspot-content').detach();
              $('.pt-lookbook-container').children().size() > 0 && (n <= 789 ? r() : s()), a(l, e, i);
            }
          })(e),
      n <= 789)
    ) {
      if ($('.pt-btn-close').is(t.target)) return r(), !1;
      $('.pt-hotspot').is(t.target) && r(),
        $(document).mouseup(function (t) {
          $('.pt-lookbook-popup').is(t.target) || 0 !== $('.pt-lookbook-popup').has(t.target).length || $('.pt-hotspot').is(t.target) || 0 !== $('.pt-hotspot').has(t.target).length || s();
        });
    }
    function s() {
      var t = $('.pt-lookbook-popup').removeAttr('style').find('.pt-hotspot-content').detach();
      $('.pt-hotspot.active').removeClass('active').find('.pt-content-parent').append(t);
    }
    function r() {
      if ($('.pt-lookbook-container').is(':has(div)')) {
        var t = $('.pt-lookbook-container').find('.pt-hotspot-content').detach();
        $('.pt-hotspot.active').find('.pt-content-parent').append(t);
      }
      $('.pt-lookbook')
        .find('.pt-hotspot.active')
        .each(function (t) {
          var e = $(this),
            n = e.attr('data-top') + '%',
            o = e.attr('data-left') + '%';
          e.removeClass('active').removeAttr('style').css({ top: n, left: o }).find('.pt-btn').removeAttr('style').next().removeAttr('style');
        });
    }
    n > 789 &&
      $(document).mouseup(function (t) {
        if ((window.innerWidth || $window.width(), $('.pt-btn-close').is(t.target))) return s(), !1;
        $('.pt-lookbook-popup').is(t.target) || 0 !== $('.pt-lookbook-popup').has(t.target).length || $('.pt-hotspot').is(t.target) || 0 !== $('.pt-hotspot').has(t.target).length || s();
      }),
      $(window).resize(function (t) {
        (window.innerWidth || $window.width()) <= 789
          ? r()
          : (s(),
            $('.pt-hotspot')
              .find('.pt-content-parent')
              .each(function () {
                var t = $(this);
                if ('block' == t.css('display')) {
                  var e = t.closest('.pt-hotspot'),
                    n = e.attr('data-top') + '%',
                    o = e.attr('data-left') + '%';
                  t.removeAttr('style').prev().removeAttr('style'), e.removeAttr('style').css({ top: n, left: o });
                }
              }));
      });
  });
}
function ptOverflowProduct() {
  blocks.ptProductDesign02.hover(
    function () {
      if ($('.pt-product-listing').length && $('.pt-product-listing').hasClass('pt-col-one')) return !1;
      if (!(window.innerWidth < 1024)) {
        var t = $(this).find('.pt-image-box').height(),
          e = $(this).find('.pt-description');
        t > e.height() + 25 || ($(this).addClass('pt-small'), e.height(t).perfectScrollbar());
      }
    },
    function () {
      window.innerWidth < 1024 || $(this).removeClass('pt-small').find('.pt-description').removeAttr('style').perfectScrollbar('destroy');
    }
  );
}
function ptReinitflowProduct() {
  window.innerWidth < 1024 ||
    0 == $ptPageContent.find('.pt-product-design02').length ||
    $ptPageContent.find('.pt-product-design02').each(function () {
      $(this).perfectScrollbar('destroy');
      var t = $(this).find('.pt-image-box').height(),
        e = $(this).find('.pt-description');
      t > e.height() + 25 || ($(this).addClass('pt-small'), e.height(t).perfectScrollbar());
    });
}
function ptPortfolioContentMobile() {
  blocks.ptPortfolioContent.on('click', 'figure img', function () {
    $(this).closest('.pt-portfolio-content').find('figure').removeClass('gallery-click'), $(this).closest('figure').addClass('gallery-click');
  });
}
function ptToggleCol() {
  var t = $ptLeftColumnAside.find('.pt-btn-col-close a');
  $('.pt-btn-toggle').on('click', function (e) {
    e.preventDefault();
    var n = $body.scrollTop() || $html.scrollTop();
    $ptLeftColumnAside.toggleClass('column-open').perfectScrollbar(), $body.css('top', -n).addClass('no-scroll').append('<div class="modal-filter"></div>');
    var o = $('.modal-filter').fadeTo('fast', 1);
    return (
      o.length &&
        o.click(function () {
          t.trigger('click');
        }),
      !1
    );
  }),
    blocks.ptBtnColumnClose.on('click', function (t) {
      t.preventDefault(), $ptLeftColumnAside.removeClass('column-open').perfectScrollbar('destroy');
      var e = -1 * parseInt($body.css('top').replace('px', ''), 10);
      $body.removeAttr('style').removeClass('no-scroll').scrollTop(e), $html.removeAttr('style').scrollTop(e), $('.modal-filter').unbind().remove();
    });
}
function ptCollapseBlock() {
  blocks.ptCollapseBlock.each(function () {
    var t = $(this),
      e = t.find('.pt-item.active'),
      n = t.find('.pt-item .pt-collapse-title');
    e.find('.pt-collapse-content').slideToggle(200),
      n.on('click', function () {
        $(this).next().slideToggle(200).parent().toggleClass('active');
      });
  });
}
function getInternetExplorerVersion() {
  var t = -1;
  if ('Microsoft Internet Explorer' === navigator.appName) {
    var e = navigator.userAgent;
    null != new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})').exec(e) && (t = parseFloat(RegExp.$1));
  } else 'Netscape' === navigator.appName && ((e = navigator.userAgent), null != new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})').exec(e) && (t = parseFloat(RegExp.$1)));
  return t;
}
function is_touch_device() {
  return !!('ontouchstart' in window) || !!('onmsgesturechange' in window);
}
function ptVideoBlock() {
  $('body').on('click', '.pt-video-block', function (t) {
    t.preventDefault();
    var e = $(this).find('.movie')[0];
    e.paused ? (e.play(), $(this).addClass('play')) : (e.pause(), $(this).removeClass('play'));
  });
}
function gridGalleryMasonr() {
  var t = blocks.ptBlogMasonry.find('.pt-blog-init').isotope({ itemSelector: '.element-item', layoutMode: 'masonry' });
  t.imagesLoaded().progress(function () {
    t.isotope('layout').addClass('pt-show');
  });
  var e = blocks.ptBlogMasonry.find('.pt-filter-nav');
  if (e.length) {
    var n = {
      ium: function () {
        return $(this).find('.name').text().match(/ium$/);
      },
    };
    e.on('click', '.button', function () {
      var e = $(this).attr('data-filter');
      (e = n[e] || e), t.isotope({ filter: e }), $(this).addClass('active').siblings().removeClass('active');
    });
  }
}
function gridProductMasonr() {
  var t = blocks.ptProductMasonry.find('.pt-product-init').isotope({ itemSelector: '.element-item', layoutMode: 'masonry' });
  t.imagesLoaded().progress(function () {
    t.isotope('layout');
  });
  var e = blocks.ptProductMasonry.find('.pt-filter-nav');
  if (e.length) {
    var n = {
      ium: function () {
        return $(this).find('.name').text().match(/ium$/);
      },
    };
    e.on('click', '.button', function () {
      var e = $(this).attr('data-filter');
      (e = n[e] || e), t.isotope({ filter: e }), $(this).addClass('active').siblings().removeClass('active');
    });
  }
}
function ptCollapse() {
  var t = blocks.ptCollapse,
    e = t.find('.pt-collapse-title'),
    n = t.find('.pt-collapse-content');
  t.each(function () {
    $(this).hasClass('open') ? $(this).find(n).slideDown() : $(this).find(n).slideUp();
  }),
    e.on('click', function (t) {
      t.preventDefault();
      var e = $(this).parent(),
        n = $(this).next('.pt-collapse-content');
      e.hasClass('open') ? (e.removeClass('open'), n.slideUp(300)) : (e.addClass('open'), n.slideDown(300));
    });
}
function ptFilterLayout(t) {
  if ($('.pt-product-listing').hasClass('only-row')) return !1;
  function e() {
    var t = blocks.ptFilterSort.find('> *').detach();
    blocks.ptFilterDetachOption.find('.filters-row-select').append(t);
  }
  function n() {
    var t = blocks.ptFilterDetachOption.find('.filters-row-select > *').detach();
    blocks.ptFilterSort.append(t);
  }
  $ptFilterOptions.hasClass('desctop-no-sidebar') && !$ptFilterOptions.hasClass('filters-detach-mobile') && (t <= 1024 ? e() : n()),
    $ptFilterOptions.hasClass('filters-detach-mobile') && (t <= 1024 ? e() : n()),
    $ptFilterOptions.hasClass('desctop-no-sidebar') || (t <= 1024 ? e() : n()),
    blocks.ptProductListing.removeClassFirstPart('pt-col-*');
  var o = $ptFilterOptions.find('.pt-quantity'),
    i = blocks.ptProductListing.find('.pt-col-item:first'),
    a = (function () {
      if (o.length && i.length) return parseInt(i.css('flex').replace('0 0', '').replace('%', ''), 10) || parseInt(i.css('max-width'), 10);
    })();
  function s(e, n) {
    t <= 1024
      ? (function (t, e) {
          t.find('.pt-show').removeClass('pt-show'), t.find('.pt-show-siblings').removeClass('pt-show-siblings');
          var n = t.find(e);
          if ((n.addClass('pt-show'), n.prev().addClass('pt-show-siblings'), 'false' == $('.pt-product-listing').data('onerow'))) return !1;
          $('.pt-col-one').addClass('pt-show-siblings');
          var o = t.find('.active').data('value');
          $('.pt-product-listing').addClass(o);
        })(e, n)
      : (function (t, e) {
          t.find('.pt-show').removeClass('pt-show'), t.find('.pt-show-siblings').removeClass('pt-show-siblings');
          var n = t.find(e);
          if (
            (n.addClass('pt-show'),
            n.next().addClass('pt-show-siblings'),
            n.prev().addClass('pt-show-siblings'),
            1 === $('.pt-quantity .pt-show-siblings').length && t.find('.pt-show-siblings').prev().addClass('pt-show-siblings'),
            !Boolean($('.pt-product-listing').data('onerow')))
          )
            return !1;
          $('.pt-col-one').addClass('pt-show-siblings');
          var o = t.find('.active').data('value');
          $('.pt-product-listing').addClass(o);
        })(e, n),
      (0 != e.find('.active').length && e.find('.active').hasClass('pt-show-siblings')) || e.find(n).addClass('active').siblings().removeClass('active');
  }
  16 == a ? s(o, '.pt-col-six') : 25 == a ? s(o, '.pt-col-four') : 33 == a ? s(o, '.pt-col-three') : 50 == a ? s(o, '.pt-col-two') : 100 == a && s(o, '.pt-col-one'),
    $('body').on('click', '.pt-filters-options a', function (t) {
      t.preventDefault(), o.find('a').removeClass('active');
      var e = $(this).addClass('active').attr('data-value');
      $ptPageContent.find('.pt-product-listing').removeClassFirstPart('pt-col-*').addClass(e), ptProductSmall();
    });
}
function gridPortfolioMasonr() {
  var t = blocks.ptPortfolioMasonry.find('.pt-portfolio-content').isotope({ itemSelector: '.element-item', layoutMode: 'masonry' });
  t.imagesLoaded().progress(function () {
    t.isotope('layout').addClass('pt-show');
  });
  var e = blocks.ptPortfolioMasonry.find('.pt-filter-nav');
  if (e.length) {
    var n = {
      ium: function () {
        return $(this).find('.name').text().match(/ium$/);
      },
    };
    e.on('click', '.button', function () {
      var e = $(this).attr('data-filter');
      (e = n[e] || e), t.isotope({ filter: e }), $(this).addClass('active').siblings().removeClass('active');
    });
  }
}
function initPortfolioPopup() {
  $ptPageContent.find('.pt-portfolio-masonry .pt-btn-zomm').magnificPopup({
    type: 'image',
    mainClass: 'mfp-zoom-in',
    gallery: { enabled: !0 },
    callbacks: {
      open: function () {
        $('body').css('height', 'unset'), $('.mfp-gallery').append('<button title="Close (Esc)" type="button" class="mfp-close">×</button>');
      },
    },
  });
}
function ptInputCounter() {
  blocks.ptInputCounter.find('.minus-btn, .plus-btn').click(function (t) {
    var e = $(this).parent().find('input'),
      n = parseInt(e.val(), 10) + parseInt('plus-btn' === t.currentTarget.className ? 1 : -1, 10);
    e.val(n).change();
  }),
    blocks.ptInputCounter
      .find('input')
      .change(function () {
        var t = $(this),
          e = parseInt(t.val(), 10),
          n = parseInt(t.attr('size'), 10);
        (e = Math.min(e, n)), (e = Math.max(e, 1)), t.val(e);
      })
      .on('keypress', function (t) {
        13 === t.keyCode && t.preventDefault();
      });
}
function ptVideoPopup() {
  blocks.modalVideoProduct
    .on('show.bs.modal', function (t) {
      var e = $(t.relatedTarget),
        n = e.attr('data-value'),
        o = e.attr('data-poster'),
        i = e.attr('data-type');
      ('youtube' !== i && 'vimeo' !== i && void 0 !== i) || $('<iframe src="' + n + '" allowfullscreen></iframe>').appendTo($(this).find('.modal-video-content')),
        'video' === i &&
          $('<div class="pt-video-block"><a href="#" class="link-video"></a><video class="movie" src="' + n + '" poster="' + o + '" allowfullscreen></video></div>').appendTo(
            $(this).find('.modal-video-content')
          ),
        ptVideoBlock();
    })
    .on('hidden.bs.modal', function () {
      $(this).find('.modal-video-content').empty();
    });
}
$('a[data-toggle="tab"]').length &&
  $('body').on('shown.bs.tab', 'a[data-toggle="tab"]', function (t) {
    $('.slick-slider').each(function () {
      $(this).slick('getSlick').refresh();
    });
  }),
  $('.modal').on('shown.bs.modal', function (t) {
    var e = $(this).find('.slick-slider');
    e.length &&
      e.each(function () {
        $(this).slick('getSlick').refresh();
      });
  }),
  (function (t) {
    t('.js-align-arrow').length && (placeArrows(), t(window).resize(placeArrows));
  })(jQuery),
  is_touch_device() && ($body.addClass('touch-device'), $html.addClass('touch-device')),
  /Edge/.test(navigator.userAgent) && $html.addClass('edge'),
  (jQuery.fn.removeClassFirstPart = function (t) {
    return this.removeClass(function (e, n) {
      var o = t.replace(/\*/g, '\\S+');
      return (n.match(new RegExp('\\b' + o, 'g')) || []).join(' ');
    });
  });
var elevateZoomWidget = {
  scroll_zoom: !0,
  class_name: '.zoom-product',
  thumb_parent: $('#smallGallery'),
  scrollslider_parent: $('.slider-scroll-product'),
  checkNoZoom: function () {
    return $(this.class_name).parent().parent().hasClass('no-zoom');
  },
  init: function (t) {
    var e = this,
      n = window.innerWidth || $(window).width(),
      o = $(e.class_name),
      i = e.thumb_parent;
    if ((e.initBigGalleryButtons(), e.scrollSlider(), 0 == o.length)) return !1;
    if (!e.checkNoZoom()) {
      var a = o.parent().parent().attr('data-scrollzoom');
      (a = a || e.scroll_zoom), (e.scroll_zoom = 'false' != a), n > 575 && e.configureZoomImage(), e.resize();
    }
    if (0 == i.length) return !1;
    e[i.parent().attr('class').indexOf('-vertical') > -1 ? 'vertical' : 'horizontal'](i), e.setBigImage(i);
  },
  configureZoomImage: function () {
    var t = this;
    $('.zoomContainer').remove(),
      $(this.class_name).each(function () {
        var t = $(this),
          e = t.removeData('elevateZoom').clone();
        t.after(e).remove();
      }),
      setTimeout(function () {
        $(t.class_name).elevateZoom({ gallery: t.thumb_parent.attr('id'), zoomType: 'inner', scrollZoom: Boolean(t.scroll_zoom), cursor: 'crosshair', zoomWindowFadeIn: 300, zoomWindowFadeOut: 300 });
      }, 100);
  },
  resize: function () {
    var t = this;
    $(window).resize(function () {
      if ((window.innerWidth || $(window).width()) <= 575) return !1;
      t.configureZoomImage();
    });
  },
  horizontal: function (t) {
    t.slick({
      lazyLoad: 'progressive',
      infinite: !0,
      dots: !1,
      arrows: !0,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      ],
    });
  },
  vertical: function (t) {
    t.slick({
      lazyLoad: 'progressive',
      vertical: !0,
      infinite: !0,
      slidesToShow: 6,
      slidesToScroll: 1,
      verticalSwiping: !0,
      arrows: !0,
      dots: !1,
      centerPadding: '0px',
      customPaging: '0px',
      responsive: [
        { breakpoint: 1239, settings: { slidesToShow: 5, slidesToScroll: 1 } },
        { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      ],
    });
  },
  initBigGalleryButtons: function () {
    var t = $('.bigGallery');
    if (0 == t.length) return !1;
    $('body')
      .on('mouseenter', '.zoomContainer', function () {
        t.find('button').addClass('show');
      })
      .on('mouseleave', '.zoomContainer', function () {
        t.find('button').removeClass('show');
      });
  },
  scrollSlider: function () {
    var t = this.scrollslider_parent;
    if (0 == t.length) return !1;
    t.on('init', function (e, n) {
      t.css({ opacity: 1 });
    }),
      t
        .css({ opacity: 0 })
        .slick({
          infinite: !1,
          vertical: !0,
          verticalScrolling: !0,
          dots: !0,
          arrows: !1,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
          ],
        })
        .mousewheel(function (t) {
          t.preventDefault(), t.deltaY < 0 ? $(this).slick('slickNext') : $(this).slick('slickPrev');
        });
  },
  setBigImage: function (t) {
    var e = this;
    t.find('a').click(function (n) {
      e.checkNoZoom() && n.preventDefault();
      var o = $(e.class_name),
        i = e.checkNoZoom() ? 'data-image' : 'data-zoom-image',
        a = e.checkNoZoom() ? 'src' : 'data-zoom-image',
        s = $(this).attr(i);
      if ((o.attr(a, s), !e.checkNoZoom())) return !1;
      t.find('.zoomGalleryActive').removeClass('zoomGalleryActive'), $(this).addClass('zoomGalleryActive');
    });
  },
};
function ptProductSingleBtnZomm() {
  $body.on('click', '.pt-product-single-img .pt-btn-zomm', function (t) {
    var e = $('#smallGallery');
    e.find('a').each(function () {
      var t = $(this).attr('data-zoom-image');
      t.length &&
        ($(this).closest('li').append("<a class='link-magnific-popup' href='#'></a>").find('.link-magnific-popup').attr('href', t),
        $(this).hasClass('zoomGalleryActive') && $(this).closest('li').find('.link-magnific-popup').addClass('zoomGalleryActive'));
    }),
      e
        .addClass('pt-magnific-popup')
        .find('.link-magnific-popup')
        .magnificPopup({
          type: 'image',
          gallery: { enabled: !0, tCounter: '<span class="mfp-counter"></span>' },
          callbacks: {
            close: function () {
              setTimeout(function () {
                e.removeClass('pt-magnific-popup').find('.link-magnific-popup').remove();
              }, 200);
            },
          },
        }),
      e.find('.link-magnific-popup.zoomGalleryActive').trigger('click');
  });
}
function ptAirSticky(t) {
  var e = blocks.ptAirSticky,
    n = blocks.ptCollapseBlock.find('.pt-collapse-title');
  t >= 1024 ? e.airStickyBlock({ debug: !1, stopBlock: '.airSticky_stop-block', offsetTop: 70 }) : e.hasClass('airSticky_absolute') && e.removeClass('airSticky_absolute'),
    $document.on('resize scroll', n, function () {
      e.trigger('render.airStickyBlock');
    }),
    n.on('click', function () {
      setTimeout(function () {
        e.trigger('render.airStickyBlock');
      }, 170);
    });
}
if ((elevateZoomWidget.init(), window.devicePixelRatio > 1))
  for (var ptImgToReplace = $('.pt-retina'), i = 0, l = ptImgToReplace.length; i < l; i++) {
    var src = ptImgToReplace[i].src;
    (src = src.replace(/\.(png|jpg|gif)+$/i, '@2x.$1')), (ptImgToReplace[i].src = src);
  }
function initStuck(t) {
  if (!$stucknav.hasClass('disabled')) {
    t = t || !1;
    var e = -1 !== getInternetExplorerVersion();
    if ('off' === t) return !1;
    $window.scroll(function () {
      var t = $('header').innerHeight();
      if ($window.scrollTop() > t) {
        if ($stucknav.hasClass('stuck')) return !1;
        $stucknav.hide(),
          $stucknav.addClass('stuck'),
          $('body').trigger('showStuck'),
          window.innerWidth < 1025 ? $ptStuckParentMenu.append($ptMobileParentMenuChildren.detach()) : $ptStuckParentMenu.append($ptDesctopMenu.detach()),
          $ptStuckParentCart.append($ptcartObj.detach()),
          $ptStuckParentCompare.append($ptCompareObj.detach()),
          $ptStuckParentWishlist.append($ptWishlistObj.detach()),
          $ptStuckParentAccount.append($ptAccountObj.detach()),
          $ptStuckParentSearch.append($ptSearchObj.detach()),
          $stucknav.find('.pt-stuck-cart-parent > .pt-cart > .dropdown').hasClass('open') || e ? $stucknav.stop().show() : $stucknav.stop().fadeIn(300);
      } else {
        if (!$stucknav.hasClass('stuck')) return !1;
        if (($stucknav.hide(), $stucknav.removeClass('stuck'), $('body').trigger('hideStuck'), window.innerWidth < 1025))
          return $ptMobileParentMenu.append($ptMobileParentMenuChildren.detach()), $ptMobileParentCart.append($ptcartObj.detach()), $ptMobileParentSearch.append($ptSearchObj.detach()), !1;
        $ptDesctopParentMenu.append($ptDesctopMenu.detach()),
          $ptDesctopParentCart.append($ptcartObj.detach()),
          $ptDesctopParentCompare.append($ptCompareObj.detach()),
          $ptDesctopParentWishlist.append($ptWishlistObj.detach()),
          $ptDesctopParentAccount.append($ptAccountObj.detach()),
          $ptDesctopParentSearch.append($ptSearchObj.detach());
      }
    }),
      $window.resize(function () {
        if (!$stucknav.hasClass('stuck')) return !1;
        window.innerWidth < 1025
          ? ($ptDesctopParentMenu.append($ptDesctopMenu.detach()), $ptStuckParentMenu.append($ptMobileParentMenuChildren.detach()))
          : ($ptMobileParentMenu.append($ptMobileParentMenuChildren.detach()), $ptStuckParentMenu.append($ptDesctopMenu.detach()));
      });
  }
}
function mobileParentSearch() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentSearch.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptMobileParentSearch.append($ptSearchObj.detach());
  } else {
    if ($ptDesctopParentSearch.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptDesctopParentSearch.append($ptSearchObj.detach());
  }
}
function mobileParentCart() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentCart.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptMobileParentCart.append($ptcartObj.detach());
  } else {
    if ($ptDesctopParentCart.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptDesctopParentCart.append($ptcartObj.detach());
  }
}
function mobileParentAccount() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentAccount.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptMobileParentAccount.append($ptAccountObj.detach());
  } else {
    if ($ptDesctopParentAccount.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptDesctopParentAccount.append($ptAccountObj.detach());
  }
}
function mobileParentCompare() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentCompare.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptMobileParentCompare.append($ptCompareObj.detach());
  } else {
    if ($ptDesctopParentCompare.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptDesctopParentCompare.append($ptCompareObj.detach());
  }
}
function mobileParentWishlist() {
  if (window.innerWidth < 1025) {
    if ($ptMobileParentWishlist.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptMobileParentWishlist.append($ptWishlistObj.detach());
  } else {
    if ($ptDesctopParentWishlist.children().lenght) return !1;
    if ($('.stuck').length) return !1;
    $ptDesctopParentWishlist.append($ptWishlistObj.detach());
  }
}
function subscribeErrorHandler() {
  if (0 == $('.errors').length) return !1;
  $('[type="email"]').on('focus', function () {
    $(this).unbind().closest('form').find('.errors').length && $(this).closest('form').find('.errors').remove();
  });
}
!(function () {
  var t = $('.pt-menu-categories');
  t.find('nav > ul > li'),
    $(this).find('.dropdown-menu'),
    $ptHeader.find('.pt-categories-toggle'),
    t.length &&
      ($body.on('click', '.pt-menu-categories button', function (t) {
        t.preventDefault(), $(this).closest('.pt-menu-categories').toggleClass('opened').find('.pt-dropdown-menu').slideToggle(200);
      }),
      t.find('nav > ul > li').each(function () {
        $(this).find('.dropdown-menu').length && $(this).closest('li').addClass('pt-submenu');
      }),
      t.find('.pt-dropdown-menu li').hover(function (t) {
        $(this).toggleClass('acitve', 'mouseenter' === t.type),
          (function (t) {
            var e = t.position().top,
              n = t.find('.dropdown-menu');
            if (!n.length) return !1;
            n.height() >= e + t.height() ? n.css({ top: 0 }) : n.css({ top: e + -29 });
          })($(this));
      }),
      t
        .find('.pt-megamenu-submenu ul li')
        .on('mouseenter', function () {
          var t = $(this).find('ul:first');
          if (t.length) {
            var e = window.innerWidth,
              n = parseInt(t.css('width'), 10) + 20,
              o = this.getBoundingClientRect().right,
              i = this.getBoundingClientRect().left;
            e - o < n ? t.addClass('right-popup') : i < n && t.removeClass('right-popup');
          }
        })
        .on('mouseleave', function () {
          $(this).find('ul:first').removeClass('right-popup');
        }),
      (function () {
        if (!$stucknav.hasClass('disabled')) {
          var t = $ptHeader.find('.pt-desctop-parent-menu-categories'),
            e = $ptHeader.find('.pt-stuck-desctop-menu-categories'),
            n = $ptHeader.find('.pt-mobile-parent-menu-categories'),
            o = $ptHeader.find('.pt-stuck-mobile-menu-categories');
          $window.scroll(function () {
            var i = $('header').innerHeight();
            $window.scrollTop() > i
              ? (e.append(t.find('.pt-menu-categories').detach()), o.append(n.find('.pt-categories-toggle').detach()))
              : (t.append(e.find('.pt-menu-categories').detach()), n.append(o.find('.pt-categories-toggle').detach()));
          });
        }
      })());
})(),
  ('undefined' == typeof eac || null === eac) && $('body').empty(),
  (function (t) {
    var n = {
      init: function (e) {
        return this.each(function () {
          var o = {
            objClass: t(this).attr('class').split(' ')[0],
            objTitle: e.titleObj,
            objAddClass: e.addClassObj || !1,
            wrapperAddClass: e.addClassWrapper || !1,
            createBlok: e.createBlok,
            objinnerEntryPoint: e.innerEntryPoint,
          };
        });
      },
    };
    (t.fn.movingObjects = function (t) {
      return n[t]
        ? n[t].apply(this, Array.prototype.slice.call(arguments, 1))
        : 'object' != typeof t && t
        ? (console.info('Action ' + t + 'not found this plugin'), this)
        : n.init.apply(this, arguments);
    }),
      t('#pt-header .single-button').movingObjects({ wrapperAddClass: 'extra-layout' }),
      t('#pt-header').find('.pt-desctop-parent-account').movingObjects({ innerEntryPoint: 'pt-dropdown-inner', createBlok: 'my-account', createBlokTitle: 'My Account' }),
      t('#pt-header').find('.pt-desctop-parent-compare').movingObjects({ createBlok: 'my-account', createBlokTitle: 'My Account' }),
      t('#pt-header').find('.pt-desctop-parent-wishlist').movingObjects({ createBlok: 'my-account', createBlokTitle: 'My Account' }),
      t('#pt-header .pt-desctop-parent-language').movingObjects({ titleObj: 'Languages', innerEntryPoint: 'pt-dropdown-inner' }),
      t('#pt-header .pt-desctop-parent-currency').movingObjects({ titleObj: 'Currency', innerEntryPoint: 'pt-dropdown-inner' }),
      t('#pt-header .pt-desctop-parent-submenu').movingObjects({ addClassObj: 'list-icon' });
  })(jQuery),
  (function () {
    var t = header_menu_timeout,
      e = header_menu_delay,
      n = !1,
      o = function () {
        var t = window.innerHeight,
          e = $(this).find('.dropdown-menu'),
          n = t - e.get(0).getBoundingClientRect().top;
        if (e.innerHeight() > n) {
          var o = $('body'),
            i = $('.pt-stuck-nav');
          e.css({ maxHeight: n - 20, overflow: 'auto' });
          var a = function () {
            var t = $('<div>').css({ overflowY: 'scroll', width: '50px', height: '50px', visibility: 'hidden' });
            o.append(t);
            var e = t.get(0).offsetWidth - t.get(0).clientWidth;
            return t.remove(), e;
          };
          o.css({ overflowY: 'hidden', paddingRight: a() }), i.css({ paddingRight: a() }), $('.pt-header-static').length && $('.pt-header-static').css({ 'padding-right': a() });
        }
      };
    $ptDesctopMenu.length > 0 &&
      ($('.pt-megamenu-submenu li').each(function () {
        $(this).find('img').length && $(this).closest('ul').addClass('pt-sub-img');
      }),
      $ptDesctopMenu.find('.dropdown-menu').each(function () {
        $(this).length && $(this).closest('.dropdown').addClass('pt-submenu');
      }),
      $(document).on(
        {
          mouseenter: function () {
            var i = $(this),
              a = this;
            (window.innerWidth || $(window).width()) > 1025 && $body.hasClass('touch-device') && $ptDesctopMenu.find('.dropdown.pt-submenu > a').one('click', !1),
              (n = setTimeout(function () {
                var t = i.find('.pt-menu-slider'),
                  n = i.find('.dropdown-menu');
                i.addClass('active').find('.dropdown-menu').stop().addClass('hover').fadeIn(e),
                  n.length & !n.hasClass('one-col') && o.call(a),
                  t.length && (t.hasClass('slick-initialized') || t.slick({ dots: !1, arrows: !0, infinite: !0, speed: 300, slidesToShow: 3, slidesToScroll: 3, adaptiveHeight: !0 })),
                  t.slick('setPosition');
              }, t));
          },
          mouseleave: function (t) {
            var e = $(this),
              o = e.find('.dropdown-menu');
            (!$(t.target && t.relatedTarget).parents('.dropdown-menu').length || $(t.target).parents('.pt-megamenu-submenu').length || $(t.target).parents('.one-col').length) &&
              (!1 !== n && (clearTimeout(n), (n = !1)),
              o.length
                ? o.stop().fadeOut({
                    duration: 0,
                    complete: function () {
                      e.removeClass('active').find('.dropdown-menu').removeClass('hover');
                    },
                  })
                : e.removeClass('active').find('.dropdown-menu').removeClass('hover'),
              o.removeAttr('style'),
              $('.pt-header-static').length && $('.pt-header-static').removeAttr('style'),
              $body.removeAttr('style'),
              $('.pt-stuck-nav').css({ paddingRight: 'inherit' }));
          },
        },
        '.pt-desctop-menu li'
      ),
      $('.multicolumn ul li').hover(
        function () {
          var t = $(this).find('ul:first');
          if (t.length) {
            var e = window.innerWidth,
              n = (window.innerHeight, parseInt(t.css('width'), 10)),
              o = this.getBoundingClientRect().right,
              i = this.getBoundingClientRect().left;
            e - o < n ? t.removeClass('left').addClass('right') : i < n ? t.removeClass('right').addClass('left') : t.removeClass('left right'), t.stop(!0, !0).fadeIn(300);
          }
        },
        function () {
          $(this).find('ul:first').stop(!0, !0).fadeOut(300).removeAttr('style');
        }
      ),
      $ptDesctopMenu.find('.pt-megamenu-submenu li').hover(
        function () {
          var t = $(this).find('ul:first');
          if (t.length) {
            var e = $(this).parents('.dropdown').find('.dropdown-menu'),
              n = e.get(0).getBoundingClientRect().left,
              o = e.get(0).getBoundingClientRect().right,
              i = e.get(0).getBoundingClientRect().bottom,
              a = parseInt(t.css('width'), 10),
              s = this.getBoundingClientRect().right,
              r = this.getBoundingClientRect().left;
            o - 20 - s < a ? t.removeClass('left').addClass('right') : r - a - 20 < n ? t.removeClass('right').addClass('left') : t.removeClass('left right'), t.stop(!0, !0).delay(0).fadeIn(200);
            var l = t.get(0).getBoundingClientRect().bottom;
            if (i < l) {
              var c = i - l;
              t.css({ top: c });
            }
          }
        },
        function () {
          $(this).find('ul:first').stop(!0, !0).fadeOut(300).removeAttr('style');
        }
      ),
      $('.megamenu div').hover(
        function () {
          $(this).children('.pt-title-submenu').addClass('active');
        },
        function () {
          $(this).children('.pt-title-submenu').removeClass('active');
        }
      )),
      $(window).on('scroll', function () {
        var t;
        (t = $('.dropdown.hover')).find('.dropdown-menu').not('.one-col').length && t.length && o.call(t);
      });
  })(),
  (function (t) {
    'function' == typeof define && define.amd ? define(['jquery'], t) : 'object' == typeof exports ? (module.exports = t(require('jquery'))) : t(jQuery);
  })(function (t) {
    var e = /\+/g;
    function n(t) {
      return i.raw ? t : encodeURIComponent(t);
    }
    function o(n, o) {
      var a = i.raw
        ? n
        : (function (t) {
            0 === t.indexOf('"') && (t = t.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\'));
            try {
              return (t = decodeURIComponent(t.replace(e, ' '))), i.json ? JSON.parse(t) : t;
            } catch (t) {}
          })(n);
      return t.isFunction(o) ? o(a) : a;
    }
    var i = (t.cookie = function (e, a, s) {
      if (arguments.length > 1 && !t.isFunction(a)) {
        if ('number' == typeof (s = t.extend({}, i.defaults, s)).expires) {
          var r = s.expires,
            l = (s.expires = new Date());
          l.setMilliseconds(l.getMilliseconds() + 864e5 * r);
        }
        return (document.cookie = [
          n(e),
          '=',
          (function (t) {
            return n(i.json ? JSON.stringify(t) : String(t));
          })(a),
          s.expires ? '; expires=' + s.expires.toUTCString() : '',
          s.path ? '; path=' + s.path : '',
          s.domain ? '; domain=' + s.domain : '',
          s.secure ? '; secure' : '',
        ].join(''));
      }
      for (var c, p = e ? void 0 : {}, d = document.cookie ? document.cookie.split('; ') : [], u = 0, h = d.length; u < h; u++) {
        var f = d[u].split('='),
          g = ((c = f.shift()), i.raw ? c : decodeURIComponent(c)),
          m = f.join('=');
        if (e === g) {
          p = o(m, a);
          break;
        }
        e || void 0 === (m = o(m)) || (p[g] = m);
      }
      return p;
    });
    (i.defaults = {}),
      (t.removeCookie = function (e, n) {
        return t.cookie(e, '', t.extend({}, n, { expires: -1 })), !t.cookie(e);
      });
  }),
  subscribeErrorHandler();
var hoverColors = {
  params: { baseColor: 'data-c', activeColor: 'data-ac', bgBaseColor: 'data-bgc', bgActiveColor: 'data-abgc', borderBaseColor: 'data-borc', borderActiveColor: 'data-aborc' },
  init: function () {
    var t = this.params,
      e = $('[data-hovercolors]');
    if (0 == e.length) return !1;
    e.each(function () {
      hoverColors.getCurrentColors($(this), t.baseColor, t.bgBaseColor, t.borderBaseColor);
    });
  },
  initEvents: function () {
    var t = this.params;
    $('body').on(
      {
        mouseenter: function () {
          hoverColors.getCurrentColors($(this), t.activeColor, t.bgActiveColor, t.borderActiveColor);
        },
        mouseleave: function () {
          hoverColors.getCurrentColors($(this), t.baseColor, t.bgBaseColor, t.borderBaseColor);
        },
      },
      '[data-hovercolors]'
    );
  },
  getCurrentColors: function (t, e, n, o) {
    hoverColors.setCurrentColors(t, e, n, o);
    var i = t.attr('data-hovercolors-not'),
      a = t.find('[' + e + ']');
    a.length > 0 &&
      a.each(function () {
        if (!$(this).hasClass(i)) {
          var t = $(this).attr(e);
          $(this).css('color', t);
        }
      }),
      (a = t.find('[' + n + ']')).length > 0 &&
        a.each(function () {
          $(this).hasClass(i) || hoverColors.setCurrentBgColor($(this), n);
        }),
      (a = t.find('[' + o + ']')).length > 0 &&
        a.each(function () {
          $(this).hasClass(i) || hoverColors.setCurrentBorderColor($(this), o);
        });
  },
  setCurrentBgColor: function (t, e) {
    var n = t.attr(e);
    t.css({ background: n });
  },
  setCurrentBorderColor: function (t, e) {
    var n = t.attr(e);
    void 0 !== n && !1 !== n && t.css('border-color', n);
  },
  setCurrentColors: function (t, e, n, o) {
    var i = t.attr(e);
    return t.css('color', i), hoverColors.setCurrentBgColor(t, n), hoverColors.setCurrentBorderColor(t, o), !1;
  },
};
function countDown(t) {
  $('.pt-countdown').length &&
    ((t = t || !1),
    $('.pt-countdown').each(function () {
      var e = $(this),
        n = e.data('date'),
        o = !1,
        i = $('[name=timezone]');
      if (('function' == typeof moment && i.length && (o = moment.tz(e.data('date'), i.attr('content'))), (n = n.split('-')))) {
        n = n.join('/');
        var a = o ? o.toDate() : n;
        e.countdown(a, function (e) {
          var n = '<span class="countdown-row">';
          function o(t, e, o) {
            (0 !== e || o) && t(n);
          }
          o(
            function () {
              n += '<span class="countdown-section"><span class="countdown-amount">' + e.offset.totalDays + '</span><span class="countdown-period">' + set_day + '</span></span>';
            },
            e.offset.totalDays,
            t
          ),
            o(
              function () {
                n += '<span class="countdown-section"><span class="countdown-amount">' + e.offset.hours + '</span><span class="countdown-period">' + set_hour + '</span></span>';
              },
              e.offset.hours,
              t
            ),
            o(
              function () {
                n += '<span class="countdown-section"><span class="countdown-amount">' + e.offset.minutes + '</span><span class="countdown-period">' + set_minute + '</span></span>';
              },
              e.offset.minutes,
              t
            ),
            o(
              function () {
                n += '<span class="countdown-section"><span class="countdown-amount">' + e.offset.seconds + '</span><span class="countdown-period">' + set_second + '</span></span>';
              },
              e.offset.seconds,
              t
            ),
            (n += '</span>'),
            $(this).html(n);
        });
      }
    }));
}
function initProductOptions() {
  $('body').on('change', '.productitem-option1-combo-js select', function (t) {
    var e = $(this).find('option:selected');
    setNewData(e, !0);
    var n = e.attr('data-tag') + '-js',
      o = e.closest('.pt-option-block');
    (n = o.optionsSetParams(n, '.productitem-option2-js')), o.optionsSetParams(n, '.productitem-option3-js');
  }),
    $('body').on('click', '.productitem-option1-js a', function (t) {
      var e = $(this);
      optionsHandler(t, e);
      var n = e.parent().attr('data-tag') + '-js',
        o = e.closest('.pt-option-block');
      (n = o.optionsSetParams(n, '.productitem-option2-js')), o.optionsSetParams(n, '.productitem-option3-js');
    }),
    $('body').on('click', '.productitem-option2-js a', function (t) {
      var e = $(this);
      optionsHandler(t, e);
      var n = e.parent().attr('data-tag') + '-js';
      e.closest('.pt-option-block').optionsSetParams(n, '.productitem-option3-js');
    }),
    $('body').on('click', '.productitem-option3-js a', function (t) {
      optionsHandler(t, $(this));
    });
}
function optionsHandler(t, e) {
  if ((t.preventDefault(), e.parent().hasClass('active'))) return !1;
  setNewData(e);
}
function setNewData(t, e) {
  void 0 === e && (e = !1);
  var n = e ? t : t.parent();
  e || (n.parent().find('.active').removeClass('active'), n.addClass('active'));
  var o = Boolean(n.data('variant_availability')),
    i = t.closest('.options-js');
  i.find('input').val(n.attr('data-var_id'));
  var a = n.attr('data-img');
  '' != a &&
    ($(window).width() > '1024' && i.find('.pt-img-roll-over').length
      ? i.find('.pt-img-roll-over img').attr('src', a).removeAttr('srcset data-src data-srcset').removeClass('lazyload')
      : i.find('.pt-img img').attr('src', a).removeAttr('srcset data-src data-srcset').removeClass('lazyload'));
  var s = i.find('.pt-btn-addtocart');
  s.attr('href', '/cart/add.js?quantity=1&id=' + n.attr('data-var_id')),
    i.find('.compare-js').length && (i.find('.compare-js').attr('data-compareid', n.attr('data-var_id')), $(window).trigger('compareevent')),
    o ? s.find('span').last().html(addtocart_text).parent().removeClass('disable') : s.find('span').last().html(unavailable_text).parent().addClass('disable');
  var r = i.find('.pt-label-sale'),
    l = i.find('.pt-price span:not(.old-price)'),
    c = i.find('.old-price');
  l.html(Shopify.formatMoney(n.attr('data-price'), money_format));
  var p = String(n.attr('data-compprice'));
  if ((c.html(Shopify.formatMoney(p, money_format)), p)) {
    var d = Number(n.attr('data-price'));
    if (d >= (p = Number(p))) !c.hasClass('hide') && c.addClass('hide'), l.hasClass('new-price') && l.removeClass('new-price'), r.length && r.hide();
    else {
      c.hasClass('hide') && c.removeClass('hide'), !l.hasClass('new-price') && l.addClass('new-price');
      var u = Math.round(100 - (d / p) * 100) + '%';
      r.length && r.show().find('.thumb_percent').html(u);
    }
  } else !c.hasClass('hide') && c.addClass('hide'), l.hasClass('new-price') && l.removeClass('new-price'), r.length && r.hide();
  $('body').trigger('refreshCurrency');
}
function eventHandler(t) {
  $('#' + t.target.id)
    .find('[data-sectionname]')
    .initSection(),
    lazyload(),
    initSkrollr();
}
function initSkrollr() {
  $('[data-bottom-top]').length && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && skrollr.init();
}
function getTabcontent(t) {
  if (!t.length || !t.hasClass('startajax')) return !1;
  t.removeClass('startajax');
  var e = {
    type: 'get',
    url: '/collections/all?view=collectiontabs&constraint=' + t.attr('data-content'),
    success: function (e) {
      var n = t.parent();
      t.replaceWith(e),
        t.hasClass('slider') &&
          (n.find('.pt-carousel-products-js').initSlick(3, 2, 2),
          placeArrows(),
          $('.spr-badge').length > 0 && $.getScript(window.location.protocol + '//productreviews.shopifycdn.com/assets/v4/spr.js')),
        lazyload(),
        $('body').trigger('refreshCurrency'),
        ptProductSmall(),
        countDown(!0);
    },
  };
  jQuery.ajax(e);
}
function headerInfoBar() {
  var t = $ptHeader.find('.pt-top-panel'),
    e = t.find('.js-toppanel-link-dropdown');
  t.each(function () {
    $(this).on('click', '.js-removeitem', function () {
      $(this).closest(t).slideUp(200);
    });
  }),
    window.innerWidth || $window.width(),
    $(document).on('mouseenter mouseleave click', '.js-toppanel-link-dropdown', function (t) {
      var e = $(this),
        n = (t.target, window.innerWidth);
      'mouseenter' === t.type && t.relatedTarget && n > 1024 ? e.addClass('is-active') : 'mouseleave' === t.type && t.relatedTarget && n > 1024 && e.removeClass('is-active'),
        'click' === t.type && n <= 1024 && e.toggleClass('is-active');
    }),
    $(window).resize(function (e) {
      t.find('.js-toppanel-link-dropdown').each(function () {
        $(this).hasClass('is-active') && $(this).removeClass('is-active');
      });
    }),
    $(document).mouseup(function (n) {
      t.is(n.target) || 0 !== t.has(n.target).length || e.removeClass('is-active');
    });
}
function findAndViewReviews() {
  var t = $('#tab_review').offset().top,
    e = $('.pt-stuck-nav').length && 0 == $('.pt-stuck-nav.disabled').length ? $('.pt-stuck-nav').height() : 0;
  $('html, body').animate({ scrollTop: t - e }, 500),
    $('#tab_review').hasClass('nav-link') ? $('#tab_review').trigger('click') : !$('#tab_review').hasClass('active') && $('#tab_review').find('.pt-collapse-title').trigger('click');
}
function initProductsSlickResize() {
  $(window).resize(function () {
    $('.pt-carousel-products').length && $('.pt-carousel-products').slick('setPosition'), $('.pt-carousel-products-js').length && $('.pt-carousel-products-js').slick('setPosition');
  });
}
function wgDefault() {
  if (0 == $('.wg-default').length) return !1;
  var t = $('.menu_language_holder').data('css'),
    e = $('.wg-default').detach().addClass('menu_language_holder');
  $('.menu_language_holder').replaceWith(e), $('<link href="' + t + '" rel="stylesheet" type="text/css" media="all">').appendTo('body');
}
hoverColors.initEvents(),
  $(document).ready(function () {
    countDown(!0), initProductOptions();
  }),
  ($.fn.optionsSetParams = function (t, e) {
    var n = this.find(e);
    return (
      0 != n.length &&
      (n
        .show()
        .find('li')
        .each(function () {
          $(this).hide().removeClass('active');
        }),
      0 != n.find('[data-current-option="' + t + '"]').length &&
        (n
          .find('[data-current-option="' + t + '"]')
          .show()
          .first()
          .addClass('active'),
        n.find('.active').find('a').parent().attr('data-tag') + '-js'))
    );
  }),
  (function (t) {
    var e = {
      init: function (e) {
        return this.each(function () {
          var e = t(this),
            n = e.find('.pt-item.active'),
            o = e.find('.pt-item .pt-accordeon-title');
          n.find('.pt-accordeon-content').slideToggle(100),
            o.on('click', function () {
              t(this).next().slideToggle(200).parent().toggleClass('active');
            });
        });
      },
    };
    (t.fn.accordeon = function (t) {
      return e[t]
        ? e[t].apply(this, Array.prototype.slice.call(arguments, 1))
        : 'object' != typeof t && t
        ? (console.info('Action ' + t + 'not found this plugin'), this)
        : e.init.apply(this, arguments);
    }),
      t('#pt-pageContent .pt-accordeon').accordeon();
  })(jQuery),
  ($.fn.ptTabs = function (t) {
    return new (function (e) {
      var n = $(e),
        o = n.find('.pt-tabs__head'),
        i = o.find('> ul'),
        a = i.find('> li'),
        s = a.find('> span'),
        r = o.find('.pt-tabs__border'),
        l = n.find('.pt-tabs__body'),
        c = l.find('> div'),
        p = t.anim_tab_duration || 500,
        d = t.anim_scroll_duration || 500,
        u = 1025,
        h = void 0 === t.scrollToOpenMobile || t.scrollToOpenMobile,
        f = void 0 === t.singleOpen || t.singleOpen,
        g = void 0 === t.toggleOnDesktop || t.toggleOnDesktop,
        m = void 0 !== t.effect ? t.effect : 'slide',
        v = void 0 !== t.offsetTop ? t.offsetTop : '',
        b = t.goToTab,
        w = $('<div>').addClass('tt-tabs__btn-prev disabled'),
        k = $('<div>').addClass('tt-tabs__btn-next'),
        C = !1,
        y = t.disableDesctop || !1;
      function S(t, e) {
        var n = {
          duration: p,
          complete: function () {
            $(this).removeAttr('style');
          },
        };
        function o(t) {
          'toggle' === m ? t.hide().removeAttr('style') : t.slideUp(n);
        }
        if (e || f) a.removeClass('active'), o(c.filter('.active').removeClass('active').find('> div').stop());
        else {
          var i = a.index(t);
          t.removeClass('active'), o(c.eq(i).removeClass('active').find('> div').stop());
        }
      }
      function P(t, e, n, o, i) {
        var s = a.index(t),
          r = c.eq(s),
          l = {
            duration: p,
            complete: function () {
              o && o(r);
            },
          };
        t.addClass('active'),
          (function (e) {
            n && n(t.find('> span')), 'toggle' === m ? (e.show(), o && o(r)) : e.slideDown(l);
          })(r.addClass('active').find('> div').stop());
      }
      function _(t, e) {
        if (t.length) var n = { left: t.get(0).getBoundingClientRect().left - o.get(0).getBoundingClientRect().left, width: t.width() };
        else n = { left: 0, width: 0 };
        e ? r.stop().animate(n, p) : r.stop().css(n);
      }
      function T(t, e) {
        var n = t.find('> span').get(0).getBoundingClientRect().left,
          i = t.find('> span').get(0).getBoundingClientRect().right,
          a = { l: o.get(0).getBoundingClientRect().left, r: o.get(0).getBoundingClientRect().right };
        n < a.l
          ? x(Math.ceil(a.l - n), a, !1, function () {
              e();
            })
          : i > a.r
          ? x(-1 * Math.ceil(i - a.r), a, !1, function () {
              e();
            })
          : e();
      }
      function j(t) {
        var e = a.first().find('> span').get(0).getBoundingClientRect().left,
          n = a.last().find('> span').get(0).getBoundingClientRect().right;
        e < t.l ? w.removeClass('disabled') : w.addClass('disabled'), n > t.r ? k.removeClass('disabled') : k.addClass('disabled');
      }
      function x(t, e, n, o) {
        var a = parseInt(i.css('left'), 10),
          s = parseInt(r.css('left'), 10),
          l = n ? 0 : p,
          c = { left: a + t };
        n
          ? (i.css(c), j(e))
          : (r.animate({ left: s + t }, p),
            i.animate(c, {
              duration: l,
              complete: function () {
                j(e), o && o(), (C = !1);
              },
            }));
      }
      return (
        o.on('click', '> ul > li > span', function (t, e) {
          var n = $(this).parent(),
            o = window.innerWidth > u;
          if (((e = 'trigger' === e), n.hasClass('active'))) {
            if (o && !g) return;
            S(n, o), _('', !0);
          } else
            T(n, function () {
              S(n, o),
                P(
                  n,
                  0,
                  function (t) {
                    o && _(t, !e);
                  },
                  function (t) {
                    if (!o && !e && h) {
                      var n = t.offset().top;
                      $('html, body')
                        .stop()
                        .animate({ scrollTop: n - 54 }, { duration: d });
                    }
                  }
                );
            });
        }),
        l.on('click', '> div > span', function (t) {
          var e = $(this).parent(),
            n = c.index(e);
          a.eq(n).find('> span').trigger('click');
        }),
        $.isArray(b) &&
          b.length &&
          $(b).each(function () {
            var t = this.elem,
              e = this.tab,
              o = this.scrollTo,
              i = this.focus;
            $(t).on('click', function (t) {
              return (
                (function (t, e, o) {
                  var i = window.innerWidth < u,
                    s = 0,
                    r = $(v),
                    l = a.filter('[data-tab="' + t + '"]'),
                    c = $(e),
                    p = {};
                  i && r.length && (s = r.height()),
                    l.hasClass('active') || (p = { scrollTop: n.offset().top - s }),
                    $('html, body')
                      .stop()
                      .animate(p, {
                        duration: d,
                        complete: function () {
                          T(l, function () {
                            S(l, i),
                              P(
                                l,
                                0,
                                function (t) {
                                  _(t, !0);
                                },
                                function () {
                                  c.length &&
                                    $('html, body').animate(
                                      { scrollTop: c.offset().top - s },
                                      {
                                        duration: d,
                                        complete: function () {
                                          var t = $(o);
                                          t.length && t.focus();
                                        },
                                      }
                                    );
                                }
                              );
                          });
                        },
                      });
                })(e, o, i),
                t.preventDefault(),
                !1
              );
            });
          }),
        n.on('click', '.pt-tabs__btn-prev, .pt-tabs__btn-next', function () {
          var t = $(this);
          if (!t.hasClass('disabled') && !C) {
            C = !0;
            var e = { l: o.get(0).getBoundingClientRect().left, r: o.get(0).getBoundingClientRect().right };
            t.hasClass('tt-tabs__btn-next')
              ? s.each(function (t) {
                  var n = $(this).get(0).getBoundingClientRect().right;
                  if (n > e.r) return x(-1 * Math.ceil(n - e.r), e), !1;
                })
              : t.hasClass('tt-tabs__btn-prev') &&
                $(s.get().reverse()).each(function (t) {
                  var n = $(this).get(0).getBoundingClientRect().left;
                  if (n < e.l) return x(Math.ceil(e.l - n), e), !1;
                });
          }
        }),
        $(window).on('resize load', function () {
          var t = window.innerWidth > u,
            e = o.innerWidth(),
            n = 0;
          if (
            (a.each(function () {
              n += $(this).innerWidth();
            }),
            t && 1 == !y)
          ) {
            var l = a.filter('.active'),
              c = l.find('> span');
            if (!f && c.length > 1) {
              var p = l.first();
              S('', t), P(p);
            }
            if (n > e) {
              if ((o.addClass('slider').append(w).append(k), i.css({ 'margin-right': -1 * (n - o.innerWidth()) }), c.length)) {
                var d = c.get(0).getBoundingClientRect().right,
                  h = s.last().get(0).getBoundingClientRect().right,
                  g = { l: o.get(0).getBoundingClientRect().left, r: o.get(0).getBoundingClientRect().right };
                d > g.r ? x(-1 * Math.ceil(d - g.r), g, !0) : h < g.r && x(g.r - h, g, !0), _(c, !1);
              }
            } else i.removeAttr('style'), w.remove(), k.remove(), o.removeClass('slider'), _(c, !1);
            o.css({ visibility: 'visible' });
          } else r.removeAttr('style');
        }),
        a.filter('[data-active="true"]').find('> span').trigger('click', ['trigger']),
        n
      );
    })($(this).eq(0));
  }),
  blocks.ptTabsGorizontal.length &&
    blocks.ptTabsGorizontal.ptTabs({
      singleOpen: !0,
      anim_tab_duration: 270,
      anim_scroll_duration: 500,
      toggleOnDesktop: !1,
      scrollToOpenMobile: !0,
      effect: 'slide',
      offsetTop: '.pt-header[data-sticky="true"]',
    }),
  $(document)
    .on('shopify:section:load', eventHandler)
    .ready(function () {
      $('[data-sectionname]').each(function () {
        $(this).initSection();
      }),
        lazyload(),
        initSkrollr();
    }),
  ($.fn.initSection = function () {
    var t = this;
    switch (t.data('sectionname')) {
      case 'header_section':
        t.find('.pt-top-panel').length && headerInfoBar(), t.find('.js-header-slider').length && t.find('.js-header-slider').headerNewSlider();
        break;
      case 'index_sectionproducts':
        t.find('.pt-carousel-products-js').initSlick(3, 2, 2);
        break;
      case 'index_instagram':
        t.index_instagram();
        break;
      case 'index_horizontaltabs':
        t.initTabs();
        break;
      case 'index_sectionlookbookmasonry':
        t.find('.pt-lookbook-init').initMasonryLookbook();
        break;
      case 'index_sectionmasonry_products':
        t.find('.pt-product-index-init').initMasonryLookbook();
        break;
      case 'index_brands':
        t.find('.pt-carousel-brands').initSlickBrands(6, 4, 3, 2, 1);
        break;
      case 'index_testimonials':
        t.find('.pt-reviewsbox-listing').initSlickTest(2, 1);
        break;
      case 'index_revolution':
        t.find('.slider-revolution').initRevolution();
        break;
      case 'index_simplebanners2':
        t.find('.js-init-carousel').initSlickBanners2();
        break;
      case 'index_revslider':
        t.find('.js-init-parallax').fnInitParallax();
    }
  }),
  ($.fn.initTabs = function () {
    var t = this;
    if (!t.find('[role="tabpanel"]').length) return !1;
    getTabcontent(t.find('[role="tabpanel"]').first().find('.ajaxcontent')),
      t.find('.nav-link').length &&
        t.on('mouseenter', function () {
          t.find('.nav-link')
            .on('click', placeArrows)
            .each(function () {
              var t = $(this).attr('href');
              getTabcontent($(t).find('.ajaxcontent'));
            });
        });
  }),
  ($.fn.fnInitParallax = function () {
    var t = this;
    function e() {
      t.each(function () {
        var t = $(this),
          e = $(this).data('orientation'),
          n = $(this).data('overflow'),
          o = $(this).data('scale');
        new simpleParallax(t, { overflow: n || !1, scale: o || 1.2, breakpoint: 790, orientation: e });
      });
    }
    t.length && e(),
      $(window).resize(function (t) {
        (window.innerWidth || $window.width()) > 790 && e();
      });
  }),
  ($.fn.headerNewSlider = function () {
    this.slick({ dots: !1, arrows: !1, infinite: !0, slidesToShow: 1, adaptiveHeight: !1 }), this.addClass('slick-show-news');
  }),
  ($.fn.initSlick = function (t, e, n) {
    this.slick({
      dots: !0,
      arrows: !0,
      infinite: !0,
      adaptiveHeight: !0,
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: t, slidesToScroll: t } },
        { breakpoint: 791, settings: { slidesToShow: e, slidesToScroll: e } },
        { breakpoint: 480, settings: { slidesToShow: n, slidesToScroll: n } },
      ],
    });
  }),
  ($.fn.initSlickTest = function (t, e) {
    this.slick({ dots: !0, arrows: !1, infinite: !0, adaptiveHeight: !0, slidesToShow: t, slidesToScroll: 1, responsive: [{ breakpoint: 790, settings: { slidesToShow: e } }] });
  }),
  ($.fn.initSlickBrands = function (t, e, n, o, i) {
    this.slick({
      dots: !1,
      arrows: !0,
      infinite: !0,
      adaptiveHeight: !0,
      responsive: [
        { breakpoint: 1230, settings: { slidesToShow: t, slidesToScroll: t } },
        { breakpoint: 1025, settings: { slidesToShow: e, slidesToScroll: e } },
        { breakpoint: 790, settings: { slidesToShow: n, slidesToScroll: n } },
        { breakpoint: 576, settings: { slidesToShow: o, slidesToScroll: o } },
        { breakpoint: 380, settings: { slidesToShow: i, slidesToScroll: i } },
      ],
    });
  }),
  ($.fn.initSlickBanners2 = function () {
    this.slick({
      dots: !0,
      arrows: !0,
      infinite: !0,
      speed: 300,
      adaptiveHeight: !0,
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 791, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    });
  }),
  ($.fn.initMasonryLookbook = function () {
    if (0 == $('body').find('.isotope_included').length) return this.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>'), !1;
    var t = this.isotope({ itemSelector: '.element-item', layoutMode: 'masonry', gutter: 0 });
    t.imagesLoaded().progress(function (e) {
      t.addClass('pt-show').isotope('layout');
    });
  }),
  ($.fn.index_instagram = function () {
    var t = this.find('[data-username]');
    if ('function' != typeof $.instagramFeed) return t.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>'), !1;
    var e = t.attr('id'),
      n = t.data('username'),
      o = t.data('hashtag'),
      i = t.data('count');
    if ('' == n && '' == o) return !1;
    $.instagramFeed({ tag: o, username: n, container: '#' + e, display_profile: !1, display_biography: !1, display_gallery: !0, styling: !1, items: i, margin: 0 });
  }),
  ($.fn.initRevolution = function () {
    if (0 == $('body').find('.revolution_included').length) return this.replaceWith('<span class="text-center" style="display: inherit;">Save and reload page.</span>'), !1;
    function t() {
      var t = $(this),
        e = t.find('li video');
      e.length &&
        (e.on('play', function () {
          $(this).parents('li').find('.video-play').addClass('pause'), $(this).parents('.tp-caption.fullscreenvideo').addClass('click-video');
        }),
        e.on('pause ended', function () {
          $(this).parents('li').find('.video-play').removeClass('pause');
        }),
        t.find('.video-play').on('click', function (t) {
          return $(this).parents('li').find('video').trigger('click'), t.preventDefault(), t.stopPropagation(), !1;
        }),
        t.on('revolution.slide.onbeforeswap', function (t, e) {
          $(this).find('.tp-caption.fullscreenvideo').removeClass('click-video');
        }));
    }
    function e(t) {
      $(this).each(function () {
        var t = $(this),
          e = function () {
            t.on('revolution.slide.onchange', function (e, n) {
              var o = $(this)
                  .find('li')
                  .eq(n.slideIndex - 1),
                i = o.find('video'),
                a = o.find('.tp-caption').attr('data-autoplay');
              if (i.length && 'true' === a) {
                var s = i.get(0);
                (s.currentTime = 0),
                  t.one('revolution.slide.onafterswap', function (t, e) {
                    s.paused && s.play();
                  });
              }
            });
          };
        t.hasClass('revslider-initialised')
          ? e()
          : t.one('revolution.slide.onloaded', function () {
              e();
            });
      });
    }
    $.fn.resizeRevolution = function (t, e, n, o) {
      if (!$(this).length || !$(t.slider).length || !t.breakpoints) return !1;
      var i = t.slider,
        a = t.breakpoints,
        s = t.fullscreen_BP || !1,
        r =
          ((e = e || {}),
          (n = n || []),
          {
            dottedOverlay: 'none',
            delay: o,
            startwidth: 1920,
            hideThumbs: 200,
            hideTimerBar: 'on',
            thumbWidth: 100,
            thumbHeight: 50,
            thumbAmount: 5,
            navigationArrows: 'none',
            touchenabled: 'on',
            onHoverStop: 'on',
            swipe_velocity: 0.7,
            swipe_min_touches: 1,
            swipe_max_touches: 1,
            drag_block_vertical: !1,
            parallax: 'mouse',
            parallaxBgFreeze: 'on',
            parallaxLevels: [7, 4, 3, 2, 5, 4, 3, 2, 1, 0],
            keyboardNavigation: 'off',
            navigationHAlign: 'center',
            navigationVAlign: 'bottom',
            navigationHOffset: 0,
            navigationVOffset: 20,
            soloArrowLeftHalign: 'left',
            soloArrowLeftValign: 'center',
            soloArrowLeftHOffset: 20,
            soloArrowLeftVOffset: 0,
            soloArrowRightHalign: 'right',
            soloArrowRightValign: 'center',
            soloArrowRightHOffset: 20,
            soloArrowRightVOffset: 0,
            shadow: 0,
            spinner: '',
            h_align: 'left',
            stopLoop: 'off',
            stopAfterLoops: -1,
            stopAtSlide: -1,
            shuffle: 'off',
            autoHeight: 'off',
            forceFullWidth: 'off',
            hideThumbsOnMobile: 'off',
            hideNavDelayOnMobile: 1500,
            hideBulletsOnMobile: 'off',
            hideArrowsOnMobile: 'off',
            hideThumbsUnderResolution: 0,
            hideSliderAtLimit: 0,
            hideCaptionAtLimit: 0,
            hideAllCaptionAtLilmit: 0,
            startWithSlide: 0,
            fullScreenOffsetContainer: '',
          });
      $.extend(r, e);
      var l = function (t) {
          return t.find(i);
        },
        c = function () {
          for (var t = window.innerWidth, e = 0; e < a.length; e++) {
            var n = a[e];
            if (!a.length) return !1;
            if (t <= n) {
              if (0 === e) return n;
              if (n > a[e - 1]) return n;
            } else if (t > n && e === a.length - 1) return 1 / 0;
          }
          return !1;
        };
      $(this).each(function () {
        var e = $(this),
          o = l(e),
          i = e.clone(),
          a = c();
        if (!o.length) return !1;
        var p = function (e, o) {
          var i = window.innerWidth,
            a = {},
            l = {},
            c = {};
          if ((s && (l = { fullWidth: i >= s ? 'off' : 'on', fullScreen: i >= s ? 'on' : 'off' }), n.length))
            for (var p = 0; p < n.length; p++) {
              var d = n[p];
              if (d.bp && 2 === d.bp.length && d.bp[0] < d.bp[1]) {
                var u = d.bp[0],
                  h = d.bp[1];
                if (u <= o && h >= o) for (var f in d) 'bp' !== f && (a[f] = d[f]);
              }
            }
          $.extend(c, r, a, l),
            $(e).show().revolution(c),
            $(t.functions).each(function () {
              this.call(e);
            });
        };
        p(o, a),
          $(window).on('resize', function () {
            var t, n, s;
            (t = function () {
              var t = c();
              t !== a &&
                (function (t) {
                  $(o).hasClass('revslider-initialised') && ((a = t || 0), o.revkill(), e.replaceWith(i), (i = (e = i).clone()), (o = l(e)), p(o, a));
                })(t);
            }),
              (s = window.innerWidth),
              (n = setInterval(function () {
                var e = window.innerWidth;
                s === e &&
                  setTimeout(function () {
                    t();
                  }, 200),
                  clearInterval(n);
              }, 100));
          });
      });
    };
    var n = this.data('speed'),
      o = 'false' != this.attr('data-fullscreen') && 768,
      i = this.attr('data-width'),
      a = this.attr('data-height');
    if (this.hasClass('revolution-default')) {
      var s = i <= 970 ? a || 1200 : 1e3,
        r = i <= 970 ? a || 1200 : 1500;
      this.resizeRevolution(
        { slider: '.tp-banner', breakpoints: [414, 767, 1025], fullscreen_BP: o, functions: [t, e] },
        { fullScreenOffsetContainer: 'header', navigationArrows: 'true', startwidth: i || 1920, startheight: a || 800 },
        [
          { bp: [0, 790], startheight: s },
          { bp: [0, 600], startheight: s },
          { bp: [0, 460], startheight: r },
        ],
        n
      );
    } else
      this.resizeRevolution(
        { slider: '.tp-banner', breakpoints: [414, 767, 1025], fullscreen_BP: 768, functions: [t, e] },
        { fullScreenOffsetContainer: 'header-static' },
        [
          { bp: [0, 768], startheight: 1300 },
          { bp: [0, 1025], fullScreenOffsetContainer: 'header' },
        ],
        n
      );
  }),
  $('body').on('click', '.pt-review, .pt-rating', function (t) {
    $(this).closest('.pt-review').length ? $('#tab_review').length && findAndViewReviews() : (window.location = $(this).closest('.pt-rating').data('url') + '?tab_review');
  }),
  $(document).ready(function () {
    if (-1 == window.location.search.indexOf('tab_review') || 0 == $('#tab_review').length) return !1;
    setTimeout(findAndViewReviews, 2e3);
  }),
  $('.pt-carousel-products-js').length || ($('.pt-carousel-products').length && initProductsSlickResize()),
  $(document).ready(function () {
    if (0 == $('.menu_language_holder').length) return !1;
    setTimeout(wgDefault, 100);
  });
var tooltip = {
  html_i: '#pt-tooltip-popup',
  html_s: '<div id="pt-tooltip-popup"><span>',
  html_e: '</span><i></i></div>',
  tp_attr: '[data-tooltip]',
  tp_mod: !1,
  init: function () {
    if (((this.tp_mod = this.get_tp_mod()), !this.tp_mod.length || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) return !1;
    this.handler();
  },
  get_tp_attr: function () {
    return this.tp_attr;
  },
  get_tp_mod: function () {
    return $(this.get_tp_attr());
  },
  get_w_width: function () {
    return window.innerWidth || $window.width();
  },
  get_html_obj: function (t) {
    return this.html_s + t + this.html_e;
  },
  check_pr_page_swatches: function (t) {
    var e = t.closest('.pt-swatches-container'),
      n = t.closest('.pt-search'),
      o = t.closest('.pt-btn-quickview'),
      i = t.closest('.pt-collapse-content'),
      a = t.closest('.wlbutton-js'),
      s = t.closest('.compare-js');
    return !!(e.length || n.length || o.length || i.length || a.length || s.length);
  },
  handler: function () {
    var t = this;
    $('body').on('mouseenter mouseleave', this.get_tp_attr(), function (e) {
      if (t.get_w_width() <= 1024) return !1;
      'mouseenter' === e.type && t.onHover($(this)), 'mouseleave' === e.type && t.offHover($(this));
    });
  },
  onHover: function (t) {
    var e = this,
      n = t.attr('data-tooltip'),
      o = $(this.get_html_obj(n)),
      i = t.attr('data-tposition'),
      a = t.attr('data-findtag');
    if ('' == n) return !1;
    $body.append(o);
    var s = void 0 !== a ? t.find(a).first() : t,
      r = o.innerHeight(),
      l = o.innerWidth(),
      c = s.innerHeight(),
      p = s.innerWidth(),
      d = s.offset().top,
      u = s.offset().left;
    if (
      ('top' == (i = void 0 !== i ? i : 'top') && ((d += -r - 20), (u += parseInt((p - l) / 2))),
      'bottom' == i && ((d += c + 24), (u += parseInt((p - l) / 2))),
      'left' == i && ((d += parseInt((c - r) / 2)), (u += -l - 24)),
      'right' == i && ((d += parseInt((c - r) / 2)), (u += p + 24)),
      this.showTooltip(o, u, d, i),
      !this.check_pr_page_swatches(t))
    )
      return !1;
    t.on('click.closeTooltip', function () {
      e.offHover($(this)), $(this).unbind('click.closeTooltip');
    });
  },
  offHover: function (t) {
    if (($body.find(this.html_i).remove(), !this.check_pr_page_swatches(t))) return !1;
    t.unbind('click.closeTooltip');
  },
  showTooltip: function (t, e, n, o) {
    var i = { opacity: 1 },
      a = (o = o || 'top');
    'bottom' == a && (a = 'top'),
      'right' == a && (a = 'left'),
      (i[a] = 'bottom' == o || 'right' == o ? '-=10px' : '+=10px'),
      t
        .css({ top: n, left: e })
        .addClass('tooltip-' + o)
        .animate(i, 200);
  },
};
$(document).ready(function () {
  tooltip.init();
});
var wl_handler = {
  action_r: 'wk-remove',
  action_a: 'wk-add',
  loader_t: 'Be patient',
  tooltip: '#pt-tooltip-popup',
  noevents: 'wkapp_load',
  init: function () {
    if (!$('.wlbutton-js').length) return !1;
    var t = this;
    $('body').on('click', '.wlbutton-js', function (e) {
      if ((e.preventDefault(), $(this).hasClass(t.noevents))) return !1;
      if ('' == t.getcustomerid()) return $('#ModalMessage').modal('show'), !1;
      var n = $(this),
        o = { action: n.attr('data-action'), text_a: n.attr('data-add'), text_r: n.attr('data-remove'), namespace: n.attr('data-type'), key: n.attr('data-productid'), value: n.attr('data-producth') };
      n.addClass(t.noevents).attr('data-tooltip', t.loader_t).trigger('mouseenter'), o.action == t.action_a ? t.add_handler(n, o) : t.remove_handler(n, o);
    });
  },
  getcustomerid: function () {
    return yanka_app.main_info.customerid;
  },
  getloadertext: function () {
    return yanka_app.loader_text;
  },
  getappurl: function () {
    return 'https://' + yanka_app.url;
  },
  add_handler: function (t, e) {
    var n = this;
    $.ajax({
      type: 'POST',
      url: n.getappurl() + '/api/add',
      data: $.extend({}, yanka_app.main_info, { namespace: e.namespace, key: e.key, value: e.value }),
      cache: !1,
      success: function (o) {
        if ((console.log('done'), t.removeClass(n.noevents).attr('data-action', n.action_r).attr('data-tooltip', e.text_r), t.hasClass('prpagebtn-js'))) {
          var i = t.attr('data-prpage-rem');
          t.find('span').last().text(i);
        }
        t.is(':hover') && t.trigger('mouseleave').trigger('mouseenter'),
          $('.pt-wishlist.pt-dropdown-obj').length &&
            $('.pt-wishlist.pt-dropdown-obj')
              .find('.pt-badge')
              .each(function () {
                var t = Number($(this).text()) + 1;
                $(this).text(t).show();
              });
      },
      error: function (e, o) {
        alert('error'), t.removeClass(n.noevents);
      },
    });
  },
  remove_handler: function (t, e) {
    var n = this;
    $.ajax({
      type: 'POST',
      url: n.getappurl() + '/api/delete',
      data: $.extend({}, yanka_app.main_info, { namespace: e.namespace, key: e.key, _method: 'DELETE' }),
      cache: !1,
      success: function (o) {
        if ((console.log('done'), t.closest('.wkpageinfo').length))
          t.closest('.product-parent')
            .parent()
            .fadeOut(400, function () {
              t.is(':hover') && t.trigger('mouseleave');
              var e = $(this).parent();
              $(this).remove(), e.children().length || e.closest('.wkpageinfo').parent().find('.wkpagenoinfo').removeClass('hide').parent().find('.wkpageinfo').remove();
            });
        else if (
          (t.removeClass(n.noevents).attr('data-action', n.action_a).attr('data-tooltip', e.text_a), t.is(':hover') && t.trigger('mouseleave').trigger('mouseenter'), t.hasClass('prpagebtn-js'))
        ) {
          var i = t.attr('data-prpage-add');
          t.find('span').last().text(i);
        }
        $('.pt-wishlist.pt-dropdown-obj').length &&
          $('.pt-wishlist.pt-dropdown-obj')
            .find('.pt-badge')
            .each(function () {
              var t = Math.max(0, parseInt($(this).text()) - 1);
              $(this).text(t), 0 == t && $(this).hide();
            });
      },
      error: function (e, o) {
        alert('error'), t.removeClass(n.noevents);
      },
    });
  },
};
wl_handler.init();
var ct = {
    mainc: '.pt-compare-table-js',
    slider: $('#pt-compare-table').find('.compare-init-slider'),
    init: function () {
      if (!$(this.mainc).length) return !1;
      $(window).resize(ct.resizeHandler);
    },
    handler: function () {
      var t = this.getSizes();
      this.setSizes(t),
        this.slider.slick('slickGoTo', 0),
        $('.pt-compare-table').removeAttr('style'),
        (t = !1),
        setTimeout(function () {
          ct.replaceSliderArrows($('.pt-image-box-last').first().position().top);
        }, 200);
    },
    setSizes: function (t) {
      $(this.mainc).each(function () {
        $(this)
          .children()
          .each(function (e) {
            $(this).outerHeight(t[e], !0);
          });
      });
    },
    getSizes: function () {
      var t = [];
      return (
        $(this.mainc).each(function () {
          $(this)
            .children()
            .each(function (e) {
              (t[e] = void 0 !== t[e] ? t[e] : 0), (t[e] = Math.max(t[e], $(this).outerHeight(!0)));
            });
        }),
        t
      );
    },
    resizeHandler: function (t) {
      $.isNumeric(t) || (t = 200),
        $('.pt-compare-table').css({ opacity: 0 }),
        $(ct.mainc).children().removeAttr('style'),
        $(ct.mainc).find('.pt-btn-addtocart').removeAttr('style'),
        setTimeout(function () {
          ct.handler();
        }, t);
    },
    replaceSliderArrows: function (t) {
      var e = $('.compare-init-slider').find('.slick-prev'),
        n = $('.compare-init-slider').find('.slick-next'),
        o = e.height(),
        i = parseInt((t - o) / 2);
      e.addClass('showarr').css({ top: i }), n.addClass('showarr').css({ top: i });
    },
    sliderinit: function () {
      this.slider.slick({
        dots: !1,
        arrows: !0,
        infinite: !0,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: !0,
        responsive: [
          { breakpoint: 1025, settings: { slidesToShow: 2 } },
          { breakpoint: 790, settings: { slidesToShow: 1 } },
        ],
      });
    },
    sliderunslick: function () {
      this.slider.slick('unslick');
    },
  },
  compare = {
    search: '&view=getproduct',
    a_a: 'wk-add',
    a_d: 'wk-remove',
    space: 'comparedata',
    com_json: {},
    com_count: 0,
    com_limit: 0,
    init: function () {
      var t = this;
      if ((this.comparepage(), !$('.compare-js').length)) return !1;
      this.selected(),
        $(window).on('compareevent', function () {
          var e = $('.compare-js');
          e.length && e.attr('data-action', t.a_a).attr('data-tooltip', e.attr('data-add')), t.setPageButtonText(e, 'data-prpage-add'), compare.selected();
        }),
        $('body').on('click', '.compare-js', function (e) {
          e.preventDefault();
          var n = $(this);
          n.attr('data-action') == t.a_a ? compare.setdata(n) : compare.deletedata(n), t.setItemLengthInBadge();
        });
    },
    comparepage: function () {
      if (!$('.comparepage').length || !this.checkEmptyPage()) return !1;
      $('.comparepage').removeClass('hide');
      var t = this,
        e = $.parseJSON(localStorage[compare.space]);
      (this.com_limit = t.getjsonsize(e)),
        $.each(e, function (e, n) {
          t.getproduct(e, n);
        });
    },
    createcomparepage: function (t) {
      var e = $('.compare-init-slider'),
        n = $('.compareitemhtml').find('.pt-item');
      this.setOptionsTable(t, n);
      var o = Object.keys(t).length;
      $('.pt-col-item').attr('data-grid', o),
        $.each(t, function (t, o) {
          var i = n.clone();
          i.find('.pt-remove-item').attr('data-compareid', t),
            i.find('.pt-img').find('a').attr('href', o.url).find('img').attr('src', o.image),
            i.find('.pt-title').find('a').text(o.title).attr('href', o.url),
            o.price < o['compare price']
              ? (i.find('.pt-price').find('.new-price').html(o.price), i.find('.pt-price').find('.old-price').html(o['compare price']))
              : (i.find('.pt-price').find('.new-price').html(o.price).removeClass('new-price'), i.find('.pt-price').find('.old-price').remove()),
            Boolean(o.available) || (i.find('.co-btn-addtocart').closest('form').remove(), i.find('.pt-label-location').children().first().remove()),
            i.find('form').find('input').val(t),
            $.each(o.data, function (t, e) {
              var n = i.find('[data-val="' + t + '"]');
              n.length && n.html(e);
            }),
            $.each(o.options, function (t, e) {
              var n = i.find('[data-val="' + t + '"]');
              n.length && n.html(e);
            }),
            e.append(i);
        }),
        $('body').trigger('refreshCurrency'),
        setTimeout(function () {
          $(window).trigger('resize'), ct.sliderinit(), $(window).trigger('resize');
        }, 500);
    },
    checkEmptyPage: function () {
      var t = localStorage[compare.space];
      return !(t = void 0 === t || 'undefined' === t) || ($('.comparepageempty').removeClass('hide'), $('.comparepage').remove(), $('.compareitemhtml').remove(), !1);
    },
    setOptionsTable: function (t, e) {
      var n = $('.pt-value[data-val="empty"]'),
        o = $('.pt-col-title.pt-compare-table-js'),
        i = $('.title-item[data-val="maintable"]'),
        a = [];
      if (!i.length) return !1;
      if (
        ($.each(t, function (t, e) {
          $.each(e.options, function (t, e) {
            'Title' != t && !a.includes(t) && a.push(t);
          });
        }),
        0 == a.length)
      )
        return !1;
      for (var s = 0; s < a.length; s++) e.append(n.clone().attr('data-val', a[s])), o.append(i.clone().text(a[s]));
    },
    selected: function () {
      var t = localStorage[compare.space];
      if ((t = void 0 === t || 'undefined' === t)) return !1;
      var e = this,
        n = $.parseJSON(localStorage[compare.space]);
      $.each(n, function (t, n) {
        var o = $('[data-compareid="' + t + '"]');
        o.length && o.attr('data-action', e.a_d).attr('data-tooltip', o.attr('data-remove')), e.setPageButtonText(o, 'data-prpage-rem');
      });
    },
    setPageButtonText: function (t, e) {
      if (t.hasClass('prpagebtn-js')) {
        var n = t.attr(e);
        t.find('span').last().text(n);
      }
    },
    getproduct: function (t, e) {
      var n = {
        type: 'get',
        url: e + '?variant=' + t + this.search,
        success: function (n) {
          (compare.com_json[t] = $.parseJSON(n)), compare.com_json[t].hasOwnProperty('url') && (compare.com_json[t].url = e + '?variant=' + t), compare.checkloadwnd();
        },
        error: function (e, n) {
          compare.deleteitem(t), compare.checkloadwnd(), console.log('product not found');
        },
      };
      jQuery.ajax(n);
    },
    checkloadwnd: function () {
      (compare.com_count += 1), compare.com_limit <= compare.com_count && compare.createcomparepage(compare.com_json);
    },
    getjsonsize: function (t) {
      return Object.keys(t).length;
    },
    setdata: function (t) {
      var e = localStorage[compare.space],
        n = t.attr('href'),
        o = this.getid(t);
      (e = void 0 !== e && 'undefined' !== e && e) ? (((e = $.parseJSON(e))[o] = n), (e = JSON.stringify(e))) : (e = '{"' + o + '": "' + n + '"}'),
        (localStorage[compare.space] = e),
        this.setPageButtonText(t, 'data-prpage-rem'),
        t.attr('data-action', this.a_d).attr('data-tooltip', t.attr('data-remove')),
        t.is(':hover') && t.trigger('mouseleave').trigger('mouseenter');
    },
    getid: function (t) {
      return t.attr('data-compareid');
    },
    deletedata: function (t) {
      var e = this.getid(t),
        n = localStorage[compare.space];
      if (void 0 === n || 'undefined' === n) return t.attr('data-action', this.a_a), !1;
      (n = $.parseJSON(n)), this.deleteitem(e);
      var o = compare.getjsonsize(n);
      if (n.hasOwnProperty(e) && $('.comparepage').length)
        return (
          (o -= 1),
          t.closest('.pt-item').fadeOut(function () {
            ct.sliderunslick(),
              $('[data-compareid="' + e + '"]').each(function () {
                $(this).closest('.pt-item').remove();
              }),
              $('.pt-col-item').attr('data-grid', o),
              ct.sliderinit(),
              ct.resizeHandler(0),
              compare.checkEmptyPage();
          }),
          !1
        );
      this.setPageButtonText(t, 'data-prpage-add'), t.attr('data-action', this.a_a).attr('data-tooltip', t.attr('data-add')), t.is(':hover') && t.trigger('mouseleave').trigger('mouseenter');
    },
    deleteitem: function (t) {
      var e = $.parseJSON(localStorage[compare.space]);
      e.hasOwnProperty(t) && (compare.getjsonsize(e) > 1 ? (delete e[t], (e = JSON.stringify(e)), (localStorage[compare.space] = e)) : localStorage.removeItem(compare.space));
    },
    setItemLengthInBadge: function () {
      var t = localStorage[compare.space];
      if (void 0 === t || 'undefined' === t) return $('.pt-compare').length && $('.pt-compare').find('.pt-badge').hide(), !1;
      (t = $.parseJSON(t)), (t = Object.keys(t).length), $('.pt-compare').length && $('.pt-compare').find('.pt-badge').show().text(t);
    },
  };
function initStickPrLeft() {
  var t = $('.stickprcol-js'),
    e = $('.stickprcolheight-js');
  function n() {
    void 0 !== t.attr('css') && t.removeAttr('css');
    var n = 1 == t.children().length ? t.children().height() : t.height();
    if (n > $(window).height()) return !1;
    if (n > e.height()) return !1;
    if ($(window).width() < 768) return !1;
    var o = t.attr('data-o'),
      i = (t.position().top, $(window).scrollTop()),
      a = e.height() - n - 10,
      s = Math.max(0, i - o + 68);
    (s = Math.min(a, s)), t.css({ top: s }), $('.zoomContainer').length && $('.zoomContainer').css({ top: s + 136 });
  }
  t.attr('data-o', t.offset().top),
    $('body').on('click', '.pt-collapse-title', function () {
      setTimeout(function () {
        n();
      }, 200);
    }),
    setTimeout(function () {
      n();
    }, 500),
    $(window)
      .resize(function () {
        t.css({ top: 0 }),
          t.attr('data-o', t.offset().top),
          setTimeout(function () {
            n();
          }, 100);
      })
      .scroll(function () {
        n();
      });
}
function onerowActiontoInit() {
  if (
    ($('.pt-quantity').find('.pt-col-one').length &&
      $('.pt-quantity')
        .find('a')
        .click(function () {
          $(this).hasClass('pt-col-one') ? onerowActiontoRight(!0) : onerowActiontoBack();
        }),
    $(window).resize(function () {
      var t = $('.pt-product-listing').hasClass('pt-col-one');
      $(window).width() < 791 ? onerowActiontoBack() : onerowActiontoRight(t);
    }),
    $('body').on('listingpageajax', function () {
      if (!$('.pt-product-listing').hasClass('pt-col-one')) return !1;
      onerowActiontoRight(!0);
    }),
    !$('.pt-product-listing').hasClass('pt-col-one'))
  )
    return !1;
  onerowActiontoRight(!0);
}
function onerowActiontoRight(t) {
  if (((t = t), $(window).width() < 791 || !t)) return !1;
  $('.product-parent').each(function () {
    if ($(this).find('.onerowactions').children().length) return !0;
    var t = $(this).find('.pt-price').first().attr('data-par', 'backtottprice').wrap('<div class="backtottprice"/>').detach();
    $(this).find('.onerowactions').append(t),
      (t = $(this).find('.pt-product-inside-hover').attr('data-par', 'backtorphov').wrap('<div class="backtorphov"/>').detach()),
      $(this).find('.onerowactions').append(t);
  });
}
function onerowActiontoBack() {
  $('.product-parent').each(function () {
    var t = $(this).find('.onerowactions');
    if (!t.children().length) return !0;
    var e = t.find('.pt-price').first(),
      n = e.attr('data-par');
    $(this)
      .find('.' + n)
      .append(e.detach()),
      $(this).find('.pt-price').first().unwrap(),
      (n = (e = $(this).find('.pt-product-inside-hover')).attr('data-par')),
      $(this)
        .find('.' + n)
        .append(e.detach()),
      $(this).find('.pt-product-inside-hover').unwrap();
  });
}
$(document).ready(function () {
  compare.init(), compare.setItemLengthInBadge(), ct.init();
}),
  $(document).ready(function () {
    $('.pt-col-one').length && onerowActiontoInit(), $('.stickprcol-js').length && initStickPrLeft();
    var t = $('body');
    $('#fixedbg').length || t.append('<div id="fixedbg"></div>'),
      $(document).on('mouseenter mouseleave', '.pt-desctop-menu li.dropdown.pt-submenu', function (t) {
        if (void 0 === $('html').attr('id') && !1 === $('html').attr('id')) return !1;
        if ('pt-boxed' == $('html').attr('id')) return !1;
        $(this);
        var e = window.innerWidth;
        t.target,
          'mouseenter' === t.type && e > 1024
            ? ($('.pt-stuck-nav').hasClass('stuck'),
              $('#fixedbg').stop().fadeIn(150),
              $('.pt-menu-categories').length &&
                $('.pt-menu-categories').hasClass('opened') &&
                !$('.pt-menu-categories').parent().hasClass('categories-btn-noclick') &&
                $('.pt-menu-categories').find('.pt-dropdown-menu').first().stop().fadeOut(150),
              $('.pt-menu-categories').length && $('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').parent().addClass('mainmenuishover'))
            : 'mouseleave' === t.type &&
              e > 1024 &&
              ($('#fixedbg').stop().fadeOut(100),
              $('.pt-menu-categories').length &&
                $('.pt-menu-categories').hasClass('opened') &&
                !$('.pt-menu-categories').parent().hasClass('categories-btn-noclick') &&
                $('.pt-menu-categories').find('.pt-dropdown-menu').first().stop().fadeIn(100),
              $('.pt-menu-categories').length && $('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').parent().removeClass('mainmenuishover'));
      }),
      $('#pt-header').mouseleave(function () {
        setTimeout(function () {
          $('#pt-header').stop().removeAttr('style');
        }, 150);
      }),
      $(window).resize(function () {
        $('#pt-header').stop().removeAttr('style'), $('#fixedbg').hide();
      }),
      $('body').on('showStuck hideStuck', function () {
        setTimeout(function () {
          $('.pt-menu-categories').length &&
            $('.pt-menu-categories').hasClass('opened') &&
            !$('.pt-menu-categories').parent().hasClass('categories-btn-noclick') &&
            $('.pt-menu-categories').find('.pt-dropdown-menu').first().stop().fadeIn(),
            $('.pt-menu-categories').length && $('.pt-menu-categories').parent().hasClass('categories-btn-noclick') && $('.pt-menu-categories').parent().removeClass('mainmenuishover');
        }, 160);
      });
  }),
  $(document).ready(function () {
    setTimeout(function () {
      $('.panel-menu').length &&
        $('.weglot_switcher').length &&
        $('.panel-menu')
          .find('.weglot_switcher')
          .find('a')
          .on('click', function () {
            var t = $(this).parent().attr('id');
            $('.pt-desktop-header')
              .find('#' + t)
              .find('a')
              .trigger('click'),
              console.log(t);
          });
    }, 100);
  }),
  $(document).ready(function () {
    $('img.lazyload').lazyload();
  });
